const editorNoteHtml = String.raw`<div class="editor-note__intro">
<p>דברי המבוא המוצגים להלן הופיעו במהדורה המודפסת של מילון רב-מילים (1997), והם מובאים כאן ככתבם וכלשונם. <strong>פתח דבר</strong>, שנכתב על-ידי פרופ' יעקב שויקה ז"ל, מציג את התפיסה המילונאית הייחודית והחדשנית שעמדה ביסודו של פרויקט רב-מילים, ואת עקרונות היסוד שהנחו את עורכיו. הדברים המופיעים תחת הכותרת <strong>המילון ומתכונתו</strong> נכתבו על-ידי פרופ' יעקב שויקה ז"ל וד"ר חיים א' כהן, והם כוללים תיאור מפורט של מבנה המילון, המידע הכלול בו ואופן עריכתו.</p>

<p>בכל מקום שבו ישנם הבדלים בין המילון בגרסתו המודפסת, כפי שהם מתוארים בדברי מבוא אלה, לבין המילון בגרסתו המקוונת – הוספנו הערה המבהירה את ההבדלים. על אפשרויות חדשות שמציע המילון המקוון (כגון מילים נרדפות, חריזה, תרגום, תשבצון ועוד), ושאינן מוזכרות מטבע הדברים במבוא זה, ניתן ללמוד מקישור העזרה המופיע באתר.</p>

<p>רחל פינקל<br />אייר תש"ע (אפריל 2010)</p>
</div>

<div class="editor-note__toc">
    <a href="#1">פתח דבר</a>
    <a href="#2">המילון ומתכונתו</a>
    <a href="#3">הערות</a>
</div>

<p class="SubTitle"><a name="1">פתח דבר</a></p>

<p class="Quate">

    <span>אבָרֵךְ אֶת ה'  אֲשֶׁר יְעָצָנִי , אַף לֵילוֹת יִסְּרוּנִי כִלְיוֹתַי.<br />

(תהילים טז ז)<br />

    </span>

       <br />

            <br />

    <span>



רָחַשׁ לִבִּי דָּבָר טוֹב, אוֹמֵר אָנִי מַעֲשַׂי לְמֶלֶךְ,<br />

לְשׁוֹנִי עֵט סוֹפֵר מָהִיר.<br />

(שם מה ב)</span></p>



    <p>

        "המילון השלם לעברית החדשה", המוגש בזאת לקהל דוברי העברית ולומדיה, בא למלא חלל ריק במילונאות העברית, ולענות על צורך אמיתי ודוחק במילון עברי-עברי חדש אשר יתאר את העברית בת זמננו מתוך תפיסה מילונית מודרנית.<br />

הוצאתו לאור כיום של מילון מקיף לעברית נראית לכאורה מעשה תמוה, נועז ואולי אף, חלילה, מיותר, שהרי (למרבה הפליאה והמבוכה) לא נעשתה כזאת בישראל זה ארבעה עשורים. מה היום, אם כך, מימים, ומה מילון זה ממילונים? על כן מתבקשים בפתח המילון דברי הסבר אחדים על הרקע לצמיחת יוזמה זו, ועל העקרונות הלשוניים והתפיסה המילונית המיוחדת שעמדו מאחוריה; את אלה אנו פורשים כעת, בדחילו ורחימו, בפני קהל הקוראים, ובמיוחד בפני אנשי המקצוע שבהם, ובראשי פרקים בלבד.<br />

        <br />



מפעלו המילוני הגדול של אליעזר בן-יהודה, שליווה את תהליך תחייתה של הלשון העברית, פתח את עידן המילונות העברית במובנה המקובל היום וסלל את הדרך לחשובי המילונאים שבאו אחריו: י' גור, א' אבן-שושן, י' כנעני ואחרים. כל אחד מאומני לשון אלה הטביע ללא ספק חותם אישי מובהק וברור על יצירתו המילונית, ועם זאת דומה שהמשותף שבתפיסתם המילונית רב על המפריד; במובן זה, לפחות, ניתן לדבר על מילונאות עברית קלאסית שהמילונים הנזכרים הם נדבכיה העיקריים, וצביונה הוא זה של מילונאות היסטורית, דיאכרונית, למדנית ומתעדת.<br />

עיצובה ופיתוחה של מילונאות זו הסתיים -  או שמא צריך לומר קפא – לפני ארבעים שנה ומעלה. מאז ועד היום - ולמעט מילון או שניים במתכונת דומה אם כי מצומצמת יותר, ועוד מילון או שניים במתכונת שונה ועם מטרות מוגדרות אחרות, שעם כל מצוינותם הרי הם יותר בגדר של מתווה למילון מאשר מילון ממש – היה על דוברי העברית להסתפק בהשלמות, במילואים

        ובעדכונים שהסתפחו למילונים הקיימים מבלי ששינו את צביונם. זאת בזמן שהעברית פושטת ולובשת צורה ללא הרף, קולטת ופולטת מילים, צירופים ותבניות לשון בקצב מסחרר לא רק מכוח תהליך התחדשותה הפנימי, אלא מעצם רצונה להדביק את התהפוכות הטכנולוגיות והחברתיות המהירות של העולם המודרני, ואף להיות שותפה מלאה להן.<br />

בכך עדיין לא מצינו את עיקרה של הבעיה, שהרי התפיסה המילונית עצמה – כולל שאלות יסוד שלה, כגון מה תפקידו של מילון ומה מטרתו, מה הוא צריך לכלול וכיצד יש לערוך אותו - עברו לאחרונה טלטלה עזה ושינויים מפליגים. שינויי תפיסה אלה הם פועל יוצא של הפעילות המחקרית האינטנסיבית שתססה בארה"ב ובאירופה (ובעיקר באנגליה, באיטליה ובהולנד) עוד מתחילת שנות השבעים, והעוסקת בתחומי הניתוח הפורמלי והממוחשב של שפות טבעיות.

התפיסות המילוניות החדשות הניבו מאז מספר לא קטן של מילונים (בשפות אחדות) הערוכים בהתאם, אך הן פסחו עד היום לחלוטין על המילונות העברית ועל דַּבָּרֶיהָ.

        <br />



למותר להדגיש כי זכותה הגדולה של המילונות העברית ההיסטורית, שמפיה אנו חיים זה כמה דורות, במקומה עומדת. לא זו אף זו: כולנו הרי מצפים בכיסופים של ממש לסיומו של מפעל "המילון היסטורי ללשון העברית" שהאקדמיה ללשון העברית טורחת בהכנתו זה למעלה משנות דור, ואשר עם סיומו יהיה בוודאי אחד משיאי היצירה היהודית הרוחנית לדורותיה. במידה מסוימת אף פותרת עשייה זו של האקדמיה את כל האחרים מלעסוק במילונות היסטורית, שהרי מי פתי ויתחרה עם מפעל אדירים זה, ועם טובי הלשונאים העוסקים בו?<br />

עם זאת, אין להכחיש את תחושת אי-הנחת הכרוכה בבלעדיות המוצהרת שיש לגישה זו של מילונות היסטורית, בלעדיות שקנתה לה אחיזה בתוכנו זה קרוב למאה שנים, ושכדוגמתה לא מצאנו בשפות אחרות. הפרדיגמה של העשייה המילונית גרסה עד עתה כביכול מעין הנחת יסוד שקבעה: או שעורכים מילון שהוא, בעיצובו, היסטורי, או שמתקינים מיני רשימות מילים ולקסיקונים 'שימושיים' שאין נפקא מינה רבה למילונות בכללה בעשייתם או בפרסומם. בעצם היוזמה לפיתוחו של מילון כשלנו, וגם בדרכי הכנתו ועריכתו, יש אפוא משום הטלת ספק בפרדיגמה זו ואף קריאת תיגר עליה. 'המילון השלם' בא לתת תיאור מקיף, מפורט ומעודכן לאוצר המילים,  הצירופים והמשמעויות של העברית בת-ימינו על כל גווניה ומשלביה, אומנם מתוך זיקה הדוקה ומפורשת למקורותיה ההיסטוריים, אבל תוך התמקדות חדה בפניה העכשוויים. הוא מנסה לעשות זאת בצורה שתהיה מועילה, מעניינת ורלוונטית לקורא, והוא נועד לכן במוצהר להיות 'שימושי', היינו לשרת נאמנה וביעילות את המשתמשים בו. על אף זאת, הוא נערך מתוך כובד ראש רב ובעמל מפרך של מחקר ושל בדיקות מקיפות, וככל שיד אנוש  - יד כהה  -  מגעת, וככל שיד המחשוב המתקדם ביותר יכולה לסייע. מ א ו ת  החלטות עריכה מתועדות, שרק מיעוטן בא לידי ביטוי תמציתי בפרק "המילון ומתכונתו" (להלן), מבטיחות טיפול שיטתי ואחיד בכל פרטי התבנית המילונית, תבנית שנבחנה מחדש לסעיפיה, סעיף אחר סעיף, מן היסוד ממש.<br />

די בעיון קל במילון כדי לראות שהוא שונה מאלה שקדמו לו בצורה משמעותית, וזאת כמעט בכל פרט מפרטי העשייה המילונית: באוצר הערכים, במבנה העיול, בלשון הביאור, בפרישת ההוראות וגוניהן, בדוגמאות, בהערות ההנחיה, במשלבים, בהערות האטימולוגיות, וכן בטיפול המקיף והמדוקדק שניתן לצירופי הלשון, ולדרך רישומם, מיונם וארגונם במילון. כדי לחדד את הדברים, נרשה לעצמנו להשתמש בלשון הכללה (שלעתים היא חוטאת, כידוע, לאמת) ונאמר, כי התפיסה המילונית העומדת מאחורי מילון זה היא סינכרונית (ולא דיאכרונית), מסבירה (ולא מגדירה), מדגימה (ולא מתעדת), מתארת (ולא נורמטיבית), ופניה מופנות בראש ובראשונה כלפי המשתמש (ולא כלפי החוקר המקצועי), אם כי גם חוקר העברית המודרנית יכול לשאוב דרכה, מתוך המילון, מידע חשוב מלוא חופניים.<br />

תקצר היריעה כאן מלתאר בהרחבה הבחנות אלו והשלכותיהן על כל פרטי התבנית המילונית; הדברים יובאו בחיבור מיוחד שיוקדש לבעיות המילונאות העברית הסינכרונית ודרכי עיצובה. את עיקרי הדברים, ככל שהם נוגעים לשימוש מושכל במילון זה, ימצא הקורא מובאים בקצרה בפרק " המילון ומתכונתו" שלהלן; כאן נסתפק בהערות עקרוניות אחדות בלבד.<br />

        <br />



ההכרעה בדבר אוצר הערכים שיש לכלול במילון היא כמובן מן ההכרעות החשובות של המילונאי. הכרעות מסוג אלה שנעשו כאן, הכוללות החלטה על השמטת קוריוזים לשוניים חולפים מצד אחד, ועל הכללתן של מילים והוראות מלשון הדיבור (ואף ממשלבים נמוכים יותר) וכן של מילים וצירופים לועזיים לא מעטים (ככל שיש להם שימוש ברור המצדיק זאת) מצד שני, לא נעשו לנוחיות המשתמש בלבד;  יש בהן הצהרה מילונית ברורה: זו תבניתה של העברית כיום.

אין מקום להתרעם על המילונאי על שברישום מילים לועזיות רבות ומילים והוראות  בעלות משלב נמוך ובלתי תקני הוא נותן להן, כביכול, 'לגיטימציה' ומעודד את השימוש בהן, שהרי הוא טרח לציין גם את אלה וגם את אלה בצורה מפורשת בציון הרומז על לועזיותן ועל תת-תקניותן (בדרגה זו או אחרת). השמטתן הייתה גורמת לכך שגם אדם המצויד במילון מקיף לא יבין כהלכה את הסביבה הלשונית שבה הוא חי ומתקיים. את המאבק על טוהר הלשון אין לנהל על גבו של המילונאי, שאינו אלא כמשקיף הרושם בשקדנות את שעיניו קוראות ואת שאוזניו שומעות.<br />



המחקר על עיבוד ממוחשב של שפות טבעיות, שאליו רמזנו למעלה, אף האיר באור חדש את החשיבות המכרעת שיש לצירופי הלשון במבנה השפה ובתהליכים הקשורים בהבנתו של טקסט כתוב, הרבה מעבר למה שדימו תחילה. ואם כך הדבר באשר לשפות כגון אנגלית וצרפתית, ודאי שכך הוא באשר לעברית, המתקשה, כשפה שמית, ל'המציא' שורשים חדשים או לקלוט 'שורשים' לועזיים, והרי היא מתרחבת בהתמדה על-ידי ייחוד צירופים חדשים לצרכיה הלשוניים. התעלמות מפן זה של הלשון היא התעלמות מ כ מ ח צ י ת ו  של מילון עברי.<br />

מחשבה רבה הוקדשה במילון זה לעקרונות הטיפול הנאות בצירופים, והונהגו בו חידושים רבים בתחום זה, ביניהם הגדרה חדה יותר של הצירופים הראויים להיכלל בו, הקפדה על נוסח הצירוף וחלופותיו, הבחנה בין צרפים לניבים, קביעת מבנה ברור ומדויק לצירוף פועלי הדורש מושא או משלים אחר, הנהגת כללים חד-משמעיים למקומו המבואר, מתן אפשרות (לראשונה במילון עברי) למשתמש לסקור במבט אחד את כל הצירופים המכילים ערך כלשהו של המילון, ציון צירופים מסוימים בחלקי דיבר, ועוד.<br />

        <br />



עיקרו של המילון הוא כמובן בביאור הערכים הכלולים בו ופירוט הוראותיהם. קביעה זו נראית טריוויאלית ומובנת מאליה, ועם זאת היא טעונה הדגשה; מי שמדפדף במילונים שונים עשוי לחוש לעיתים שה"הגדרה" של המילה כפי שהיא מופיעה שם אינה אלא  "סרח עודף" שהמילונאי מנסה לפוטרו כלאחר יד כדי להיפנות לעיסוקים מילוניים החשובים לו יותר. גם בעניין זה נקצר בהצגת הגישה הנקוטה כאן ונסתפק במובאה אחת ובדוגמה אחת בלבד. המובאה היא מתורתו של זליג הריס, מן המקוריים שבבלשני הדור האחרון, שאמר (בקירוב): "המשמעות של ישות לשונית מתמצית ביחסיה עם ישויות לשוניות אחרות", לאמור: משמעות המילה היא במידה מכרעת תלוית הקשר.  כדוגמה, נעיין בתואר 'חם' המוגדר על-ידי החשוב שבמילונים העבריים שבדור האחרון בהוראה אחת כדלהלן: "בעל טמפרטורה גבוהה  פחות או יותר".<a href="#Note1">(1)</a>  והנה, לא הרי המשמעות של 'חם' במשפט "המרק חם" (יש לו טמפרטורה גבוהה), כהרי משמעותו במשפט "המעיל חם" (מחמם, לו עצמו אין טמפרטורה גבוהה), ולא הרי זו כהרי משמעותו ב- "הוא אדם חם" (לבבי ופתוח, ולא שיש לו חום, כי אז היה חולה), ולא הרי אלו  כמשמעותו ב-"זו ידיעה חמה" (שזה עכשיו הגיעה), וב-"זהו גבול חם" (רווי סכסוכים), ועוד. מאידך, אין אומרים על אדם שיש לו טמפרטורה גבוהה "הוא חם", אלא "יש לו חום". לא ניתן לפתור את כל גוני המשמעויות הללו בהנפת יד ולהכריז עליהם כ"הוראות שאולות", שהרי אין אומרים "ידיעה קרה" (אלא ישנה) ואף לא "גבול קר" (אלא שקט), וכד' (והקורא חד העין יבחין בוודאי שהציון "בהשאלה" המקשט הוראות רבות במילונים קיימים, נעדר לחלוטין ממילוננו). הוראות אלה אינן ניתנות לניחוש והן חייבות, אם כן, להופיע במילון; תעיד על כך העובדה שבשפות אחרות אין הן תמיד קיימות או שהן מובעות בהן במילים אחרות.<br />

ניתוח הוראותיה של המילה לגווניה השונים, ופרישת עושר המשמעויות שלה לפי הקשריה, הוא מגילוייו ומהישגיו המרגשים והחשובים של השימוש בקורפוסים ממוחשבים גדולים. עיסוקו העיקרי  - והמרתק - של המילונאי והלקסיקוגרף כיום מתמצה בעיקר בקבלתן מן המחשב של מאות ואלפי עדויות של המילה מתוך הקורפוס המתאים, מיונן וקיבוצן (שוב בעזרת המחשב) לפי הוראות שונות, תוך אנליזה סמנטית מקיפה ותוך בדיקה שאומנם הוראות אלה מפרנסות כיאות כל אחת מהן.<br />

אילו זכינו, היה מילון זה יוצא לאור כשכל ערכיו, צירופיו, הוראותיו ודוגמאותיו נשענים על קורפוס ממוחשב מקיף של העברית המודרנית. אלא שהקמתו של קורפוס כזה ושל התוכנה החייבת ללוותו איננה בראש מעייניה של המו"לות הישראלית המסחרית (ואולי גם לא לפי מידת יכולתה הכספית), ואילו הגורמים המופקדים על המשאבים הלאומיים אינם רואים עדיין, ככל הנראה, בהקמתו של קורפוס כזה יעד לאומי דחוף. ועוד חזון למועד.<br />

        <br />



לעיצובו של המילון ולגיבוש מדיניות העריכה שלו תרמו תרומה מרכזית חברי ועדת ההיגוי: משה זינגר (ז"ל), פרופ' ראובן מירקין, פרופ' רפאל ניר, פרופ' מנחם צבי קדרי ופרופ' אורה שורצולד. הסתייענו רבות בעצתם הטובה והנאמנה, ותודתנו העמוקה להם על כך. תודה מיוחדת לפרופ' ניר, שמתורתו שבכתב ושבעל-פה בנושא הצירופים והניבים שאבנו מלוא החופניים, וחותמו הברור טבוע היטב במדיניות שאימצנו בתחום זה. תודה גם לפרופ' מירקין על הערת אגב שלו (בכלל הערותיו הרבות) בדבר הצורך והתועלת שבסימון מיוחד למילים לא עבריות, אשר התגלגלה (על-ידינו) לכדי מנגנון שלם ומורכב לרישום מסודר של הערות אטימולוגיות המעשירות את המילון ומרבות, כך אנו מקווים, את תועלתו. ברכה ותודה לפרופ' קדרי, אשר בהתלהבות ובמרץ נעורים עבר על גרסה שלפני אחרונה של מילון זה במלואה, והעיר עליה הערות חשובות ומועילות. למותר להוסיף שתרגום תרומתם הברוכה של אנשי מקצוע אלה לעשייה המילונית בפועל נעשה על-ידי המערכת, ורק עליה חלה האחריות לנוסח הסופי של המילון, ובמיוחד לטעויות ולאי-הדיוקים אשר הסתננו, ללא ספק, לתוכו.

        <br />

כאן גם המקום להודות למרכז לטכנולוגיה חינוכית (מטח) על האכסניה החמה, האוהדת והתומכת שנתן למפעל 'רב-מילים' מאז ייסודו בסוף 1988, ובמיוחד במשך ארבע השנים האחרונות שהוקדשו להפקתו של מילון זה ושל אחיו הצעירים, מילון 'רב-מילים הצעיר' ומילון 'רב-מילים לבית הספר'.<br />

ולא אחסוך פי מלהכיר טובה למו"לים של מילונים אלה, אשר היטו שכמם לסבול עול כבד של השקעות פיתוח, מהגדולות, אולי, שהיו למו"לות הישראלית המקורית בעת האחרונה. מהם גם למדתי, בדרך קשה ומיוסרת מאוד, את חשיבות האיזון העדין (מצד אחד) והגורלי (מצד שני) שבין חזון למציאות ובין שאיפה למימוש. להט החרב המתהפכת של מפעלים דומים שנרקמו על-ידי גדולים וטובים מאיתנו וכשלו באמצע הדרך מכובד המשימה ומקושי האיחוי בין הרצוי למצוי האיץ אף הוא בנו לסיים את המלאכה, גם אם רחוקה היא עדיין מהשלמות הנרצית.



אבותינו, בצניעותם ובענוותם, היו מלווים כל ספר שיצא מ"מזבח הדפוס" במשפט התנצלות "כשם שאי-אפשר לבר בלא תבן כך אי-אפשר לדפוס בלי טעויות", והדברים בוודאי יפים ונאותים למילון מורכב ומקיף כשלנו, אף אם הושקעו בו כל העמל, האהבה והכישרון וכל התחכום של המחשוב המתקדם ביותר. אנו מאמינים, עם זאת, כי הצבנו במילון זה יסוד איתן ליצירה לשונית שעוד יכולה ועשויה להשתכלל, ואם הותרנו בה זיזים חשופים כלשהם או השמטנו ממנה ציצים ופרחים הראויים לה, לא ירחק בוודאי היום והיא תיפטר מאלה ותעוטר באלה תוך עדכון והתחדשות, כיאה לשפה שהיא מתארת.

        <br />

מילון זה הוא בעיקרו עבודת צוות, ואף בכך יש אולי מן החידוש בנוף המילונאות העברית; נשמעים בו ניגוניה של תזמורת שלמה, עם מנצח קצר שרביט המנסה ליצוק פרשנות אישית משלו ליצירה, תוך הקפדה על תיאום והרמוניזציה בין כלי המיתר, כלי הנשיפה והתופים הרועמים. אשר על כן זכות גדולה היא לו להודות לכל מי שסייעו -  אם במישרין ואם בעקיפין  -  בהבאת מילון זה לסיומו, הן אלה המוזכרים במפורש בשמותיהם בשערי המילון והן אלה (והם רבים) שאינם מוזכרים שם. שכרנו ושכרם הוא בתקווה שמילון זה ימצא חן ושכל טוב בעיני קוראיו, יגביר את ידיעת העברית ויגדיל את חיבתה וחינה בעיני דובריה.<br />

<br />

<span><strong>יעקב שויקה</strong></span> <span>חנוכה תשנ"ז</span>								

    </p>

    <br />    <br /> 

    <p class="SubTitle"><a name="2">המילון ומתכונתו</a></p>    

    <div>

    <table dir="rtl">

        <tr>

            <td>א. <a href="#a">אוצר הערכים</a> </td><td>ב. <a href="#b">העיול ('כניסת' הערך)</a></td><td>ג. <a href="#c">הצירופים</a></td><td>ד. <a href="#d">חלקי הדיבר</a></td> <td>ה. <a href="#e">משלבים</a></td>

        </tr>

        <tr>

           <td>ו. <a href="#f">תחומים</a></td><td>ז. <a href="#g">הערות אטימולוגיות</a></td><td>ח. <a href="#h">הערות הנחיה</a></td> <td>ט. <a href="#i">הביאור</a></td><td>י. <a href="#j">הדוגמאות</a></td>

        </tr>

        <tr>

           <td>יא. <a href="#k">האפארט הדקדוקי</a></td><td>יב. <a href="#l">משפחות המילים</a></td> <td>יג. <a href="#m">שיטת הכתיב והניקוד</a></td><td>&nbsp;</td><td>&nbsp;</td>

        </tr>     

    </table>

    </div>

        <br />

        <p>

        <span class="SubTitle2">א. <u><a name="a">אוצר הערכים</a></u><br />

        </span><br />



כפי ששמו מעיד עליו נועד המילון להכיל את אוצר המילים והצירופים של העברית בת-זמננו. עם זאת אין כמובן לשכוח שהעברית החדשה הכתובה והדבוּרה אינה מנותקת ממקורותיה הקלאסיים של השפה אלא להיפך, היא שואבת מכל מה שמעניקה לה הלשון העברית לדורותיה. לפיכך כללנו במילוננו אוצר מילים רחב מן המקרא (למעשה כללנו כמעט את כל אוצר המילים המקראי), מספרות חז"ל, מספרות ימי הביניים ומהספרות הרבנית לגווניה השונים (הלכה, פילוסופיה, מוסר וכד') – כל מה שנראה היה לנו שהוא עומד וקיים גם בלשוננו כיום והקורא העברי המשכיל יכול לפוגשו במהלך קריאתו. מאידך ויתרנו על מילים וצורות לשון נדירות שקיומן הוא כמעט חד-פעמי בלשון, רובן בלשון הפיוט לדורותיו (' הַבְטיה' – הבעה, 'תוויכה' -  חצייה, 'עמיצה' – סגירה) ומיעוטן חידושים לשוניים חד-פעמיים של סופרים וכותבים, שנתחדשו לרוב בדורות האחרונים מאז תחייתה של הלשון העברית בדיבור פה, אך לא הייתה להן עדנה והן לא זכו להיכנס לשימוש מעשי בלשון ('ישבן' – קולוניאלי, 'התנשות' – פמיניזם, 'גשמן' -  מטריאליסט, 'דחפוני' – אימפולסיבי). כן השמטנו מילים המופיעות במילונים כמעשה גזירה אוטומטי במשקלים ידועים ואין להן קיום של ממש בלשון ('הִתְרוֹחֲנוּת' – היעשות רוחני, 'היבוכות' – היות נבוך). כל קיומן של מילים אלו אינו אלא במילונים שרשמום והרי הן בחזקת קוריוז חולף בלבד.

            <br />

גם בחידושי האקדמיה ללשון העברית נהגנו בצורה בררנית: חידוש שכבר נקלט בשפה הובא במילון ללא ציון מיוחד; חידוש או הצעה שפורסמו בעת האחרונה, ויש בהם שימוש כלשהו, אך מעמדם (וגורלם) אינו ברור עדיין, הובא עם הערה בנוסח: 'מונח שנקבע על-ידי האקדמיה' (<strong><em>מִגְדּוֹל</em></strong>

            ['עמוד חשמל גבוה'], <strong><em>גָּשׁוֹשׁ</em></strong> ['מכשיר לבדיקת שיניים']) ואילו חידושים שפורסמו לפני זמן רב ולא זכו להיקלט, לא הובאו במילון כלל (<strong><em>דְּיוֹת</em></strong>

            <a href="#Note2">(2)</a> [סוג של דיו, ' טוּשׁ]). 

לעומת השמטות אלה כללנו במילון את כל המילים שבעברית בת-זמננו על כל משלביה: מן המשלב המליצי והספרותי ועד לזה של לשון הדיבור, הסלנג ואף ההמוני. כן כללנו אלפי מונחים מתחומי מדעי הטבע והטכנולוגיה, הרפואה, התקשורת והמחשבים, האומנות והתרבות, שהתאזרחו בשפה והם היום חלק ממטענו הרוחני של כל קורא משכיל. ויתרנו כמובן על הבאתם של מילים וצירופים שהם בבחינת מונחים המיוחדים למקצועותיהם (כולל אלה הרשומים במילוני האקדמיה ללשון העברית) והעשויים לכן להופיע אך ורק בפרסומים מקצועיים. ממונחים אלה הכנסנו רק את אלה שאינם נחלתם של אנשי המקצוע בלבד.<br />

            <br />

            <strong>תחיליות וסופיות</strong><br />

כערכים עצמאיים הצגנו במילון גם את המילים המשמשות כתחיליות בצירופים ונתַנו להם חלק דיבר בהתאם לתפקיד זה (<strong><em>קְדַם-,</em></strong> <strong><em>תת-</em></strong>,

            <strong><em>דּוּ-</em></strong>). כך יוכל המעיין לעמוד מקרוב ועל נקלה על ההבדל שבין 

            <strong><em>בן</em></strong> (בֵּן) במשמעותו השמנית הרגילה לבין  <em><strong>בן </strong>

            </em>(בֵּן) המשמש כתחילית, כרכיב ראשון בצירופים (<strong><em>בן-חורין</em></strong>).

            הערך המשמש כתחילית צוין בכניסה במקף (<strong><em>בן-</em></strong>). לפיכך הוא אף אינו משמש כהומוגרף ולא צוין במספר המסמן הומוגרף.

חידוש של ממש הנהגנו במילוננו בהציגנו כערכים עצמאיים רכיבי הלחמים, תחיליות וסופיות לועזיות הנושאות משמעות. כך, למשל, הצגנו את הערך <strong><em>–לוגיה</em></strong> (כשמקף בתחילתו מעיד על היותו רכיב סופי בהלחמים) והסברנוהו לפרטיו ("רכיב אחרון במילים מורכבות" וכו' – ראה שם). כמאה ועשרים תחיליות וכשמונים סופיות כאלה מופיעות במילוננו (ובכללם <strong><em>גסטרו-</em></strong>,

            <strong><em>היפו-</em></strong>, <strong><em>פולי-</em></strong>, <strong><em>-ונִים</em></strong>,

            <strong><em>-פיל</em></strong>, <strong><em>-מטרי </em></strong>ועוד ועוד). במילים המכילות רכיבים אלו (<strong><em>פילולוגיה</em></strong>, <strong><em>גסטרונומיה</em></strong>

            וכד') ציַינו את פירוק המילה ורכיביה מבלי להסביר רכיבים אלה שכן הם מוסברים במקומם (ראה בפרק ז בסעיף ההלחמים).

            <br />

            <br />

            <strong>



שמות פרטיים</strong>

            <br />

כנהוג במילונות העברית לא נכללו במילון זה ערכים שהם שמות אנשים.<a href="#Note3">(3)</a>  עם זאת מופיעה בו קבוצה מצומצמת של שמות דמויות מיתולוגיות, מקראיות, ספרותיות, פולקלוריסטיות או היסטוריות אשר חדרו לשפה כמושגים סטריאוטיפיים (<strong><em>שמשון</em></strong>,

            <strong><em>וֶנוס</em></strong>, <strong><em>קזנובה</em></strong>, <strong><em>דון קישוט</em></strong>).

            בצירופים הכוללים שמות אנשים (<strong><em>ביצת קולומבוס</em></strong>, <strong><em>סולם ריכטר</em></strong>) נרשמה בתחילת הביאור הערה ביוגראפית קצרה, וכן נרשם במקום האלפביתי המתאים ערך הפניה משם לצירוף עצמו כנהוג בכל הצירופים (<strong><em>קולומבוס</em></strong>&gt;&gt;<strong><em>

                ביצת קולומבוס</em></strong>&gt;&gt;;<a href="#Note4">(4)</a>  על ההפניות לצירופים ראה להלן בפרק ג).

בהתאם למגמה המסתמנת כיום במילונאות הזרה המודרנית כללנו במילון את שמות כל המדינות בעולם, וכן הבאנו כערכים לעצמם את המטבע הרשמי הנהוג בכל מדינה ומדינה (מטבע עיקרי  ומטבע קטן: <strong><em>דולר</em></strong>, <strong><em>סנט</em></strong>,

            <strong><em>לירה</em></strong>, <strong><em>גרוש</em></strong>), את השפה, את עיר הבירה, ועד שלוש ערים מרכזיות או חשובות שבכל מדינה. כן כללנו את שמותיהן של תת-מדינות (בארצות הברית, בגרמניה, ובאוסטרליה) וכן שמות של קבוצות אתניות או דתיות ושל לאומים שונים (המוצגים על פי רוב בצורת היחיד: <em><strong>בהאי</strong></em>, <strong><em>בפטיסט</em></strong>,

            <strong><em>בֶּרְבֶּרִי</em></strong>), ואף שמות של עמים קדומים (<em><strong>עמון</strong></em>)

            או של ממלכות קדומות (<strong><em>אשור</em></strong>) ככל שיש בהם עניין לקורא הישראלי בגלל ההקשר המקראי, היהודי או הגיאוגרפי-אזורי שלהם. המילון כולל את שמות כל מקומות היישוב בארץ שבהם למעלה מ- 5000 תושבים (בהשמטות מעטות, ולפי המפקד האחרון שעמד לרשותנו), וכן מבחר של שמות גיאוגרפיים בארץ, ובהם הרים, נחלים וּואדיות, חבלים, עמקים, אתרים היסטוריים וארכיאולוגיים ועוד.<br />

כן כולל המילון מבחר של שמות גיאוגרפיים בעולם (ובהם יבשות, אוקיאנוסים, נהרות, הרים, חבלי ארץ, מדבריות ואתרים שונים), של כוכבים וגרמי שמיים אחרים, של ארגונים חשובים, של חגים ומועדים וכן שמותיהם וכינוייהם של ברכות, תפילות וקטעי תפילות.

אין המילון כולל שמות יצירות, למעט עשרים וארבעה ספרי המקרא והחיבורים הנכללים בספרות התנאים והאמוראים, ולמעט חיבורים ספורים נוספים ששמותיהם נכללו במילון מסיבות שונות (הכורזי, הזוהר), פעמים כערכי משנה לערכים שאינם שמות פרטיים.&nbsp;</p>

<p>

    <span class="SubTitle2">ב. <a name="b">העיול ('כניסת' הערך)</a><br />

        </span><br />

כל הערכים והצירופים הראשיים מיוצגים ב'כניסה' הראשית בכתיב חסר הניקוד (המלא), כשלצידו מופיע הערך או הצירוף הראשי בצורתו בכתיב המנוקד ובניקוד מלא (<strong>פינה</strong>

    – פִּנָּה; <strong>שולחן</strong> - שֻׁלְחָן). <a href="#Note5">(5)</a>  למען אחידות העיצוב וכדי שהקורא

    ימצא תמיד את המילה כתבניתה המופיעה לרוב בטקסט מצוי (היינו כשהיא אינה מנוקדת), הקפדנו

    על הופעה כפולה זו גם כאשר שני הכתיבים זהים (<strong>מברק</strong> - מִבְרָק).<br />

    באופן ייצוג הערך נקטנו את השיטה המקובלת במילונאות העברית החדשה (בעיקר במילונאות

    הדו-לשונית). הפועל לבנייניו מוצג בצורת עבר נסתר (<em><strong>לבש,</strong></em>

    <strong><em>הכתיב</em></strong>, <strong><em>התאפק</em></strong> וכד'), והשם בצורת

    היחיד בנפרד.<br />

    עם זאת ייחדנו עיול נפרד לשם עצם בנקבה, גם אם צורה זו גזורה מצורת הזכר, וזאת באשר

    לכל שמות בעלי החיים ממין נקבה (<em><strong>פרה</strong></em>, <strong><em>כבשה</em></strong>),

    כל השמות המייצגים קשרי משפחה (<em><strong>חמות</strong></em>, <em><strong>גיסה</strong></em>,

    <strong><em>דודה</em></strong>), השמות בצורת הנקבה שנתייחדה להן משמעות שאין לצורת

    הזכר (<strong><em>גננת</em></strong>) או שהן אופייניות במיוחד למין זה (רקדנית),

    וכמובן לכל הצורות שצורת גזירתן הנקבית אינה צפויה (<strong><em>גברת</em></strong>).

    יתרה מזו, אף הנהגנו במילוננו את הצגתם של ערכים בצורות נטויות בכל מקום שראינו בכך

    צורך, בדרך כלל במקום שהצורה הנטויה היא הצורה המשמשת בלשון, וצורת הנפרד איננה קיימת

    אלא להלכה. כך, למשל, הצגנו את הערכים <strong><em>בְּעֶטְיו</em></strong> (ובאות

    בי"ת!)ֹ <strong><em>זוגתו</em></strong>, ולא את הערכים 'עֲטִי' או 'זוּגָהּ' שאינם

    משמשים למעשה כמילים בלשון. כן רשמנו <strong><em>יוצלח</em></strong> כערך עצמאי (באות

    יו"ד) <strong><em>הב</em></strong> (באות ה"א) וכד', אולם כיוון שמדובר בפעלים נטויים

    הוספנו גם ערכים המציגים את הצורה היסודית התיאורטית (<em><strong>הוצלח</strong></em>,

    <em><strong>יהב</strong></em>) וציינו בהוראתם שהם אינם אלא צורת עבר משוחזרת של צורה

    אחרת. נמנענו אף מלהעמיד כערך צורות יחיד תיאורטיות שאינן קיימות למעשה, ולפיכך אין

    במילוננו, למשל, 'חתחת'<a href="#Note6">(6)</a>  אלא <strong><em>חתחתים</em></strong>

    ולא '<span>שֶׁלַח</span>' אלא <em><strong>שלחין</strong></em>;

    נהגנו כך גם כאשר צורת היחיד נדירה ואינה משמשת בעברית של ימינו. במקרים כאלה ציינו,

    לפי הצורך, בהערה לצורת היחיד אם היא קיימת בשימוש לא נפוץ בלשון (<strong><em>משאבים</em></strong>:

    צורת היחיד 'משאב' נדירה). <a href="#Note7">(7)</a> כערכים עצמאיים העמדנו במילון גם מילים שבמקורן הן צירופי

    יחס אלא שמילת היחס נתלכדה ומשמשת בהן כחלק בלתי נפרד של המילה (<strong><em>כאילו</em></strong>,

    <strong><em>כלומר</em></strong>, <strong><em>להבדיל</em></strong>).<br />

נקטנו בגישה זו גם באשר לתוארי הפועל שיסודם בשם עם מילת יחס. תוארי פועל כאלה הובאו במקומם האלפביתי על-פי מילת היחס בכל מקום שלשֵם לעצמו אין שימוש חופשי. לפיכך המעיין במילון המבקש את פירושן של המילים  <strong><em>בחוזקה</em></strong> או <em><strong>ביעף</strong></em>

    ימצא את הערכים האלה באות בי"ת, וכך  <em><strong>לכתחילה</strong></em> – באות למ"ד ואף  <strong><em>מלכתחילה</em></strong> – באות מ"ם.<br />

במקום שלשֵם יש קיום עצמאי בלשון ועם זאת נראה היה לנו שתואר הפועל עם מילת היחס מחייב הצגת ערך נפרד (בשל ריחוק המשמעות וכיו"ב) הבאנו את תואר הפועל גם כערך משנה של השם עם הפניה למקומו האלפביתי. כך ימצא המעיין את <strong><em>כיאות</em></strong>, <strong>

        <em>כהלכה</em></strong> במקומם באות כ"ף, אך בערכים <em><strong>יאוּת</strong></em>

    (שם תואר), <strong><em>הלכה</em></strong> (שם עצם) הוא ימצא ערכי משנה <strong><em>כיאות</em></strong>,

    <strong><em>כהלכה</em></strong> המפנים לערכים עצמאיים. במקום שתואר הפועל עומד עדיין בזיקה הדוקה וישירה לשם הוא הובא כערך משנה בתוכו (<strong><em>במהירות</em></strong>

    בתוך <strong><em>מהירות</em></strong>, <em><strong>בגלוי</strong></em> בתוך <strong>

        <em>גלוי</em></strong>).

    <br />

עוד הוספנו לנוחיות המשתמש עיולים לכל צורות הריבוי שאינן צפויות (<strong><em>אנשים</em></strong>,

    <em><strong>אחיות</strong></em>, <em>אימהות</em>, <strong><em>פיות</em></strong>,

    <strong><em>ימים</em></strong>) המפנים אל הערך ביחיד, ולעוד צורות נטויות יוצאות דופן. <a href="#Note8">(8)</a>

    <br />

בתחתיתו של כל  עמוד ימצא המשתמש רשימה מרוכזת של מילים שמקומן האלפביתי הוא באותו עמוד מסוים, ובה ציון חלופות כתיב סדירות, כגון כתיב מנוקד ('חסר') לעומת כתיב חסר ניקוד (<em>חִבֵּב </em>- <em>חיבב)</em> וכן חלופות כתיב שכיחות דוגמת א-ה, ז-ס, ם-ן, וכד' (דוגמא – דוגמה, מוסיקה – מוזיקה, נישואין – נישואים) וחלופות כתיב וצורה לא שגרתיות (חיפני – חיפאי) עם הפניה לערך כפי שהוא מופיע במילון. 

    <br />

    <a href="#Note9">(9)</a> באמצעות רשימה זו ביקשנו להבטיח מצד אחד את מקומה במילון של צורת כתיב מסוימת (למקרה שהמשתמש יחפש את המילה לפי כתיב זה) ומאידך למנוע את ניפוחו של המילון ואת סרבולו מבחינה חזותית באמצעות הכנסת מספר רב של עיולים שאינם אלא עיולי הפניה.

    <br />

    <br />

    <strong>



הומוגראפים וסדרם</strong> <a href="#Note10">(10)</a><br />

מילים שוות צורה (הומוגראפים), שמקומם בסדר האלפביתי הוא משום כך זהה, צוינו במילוננו במספר קטן ('ציין') הבא בצמוד לתחתיתה של האות האחרונה. סדר ההומוגראפים הוא בדרך כלל פועל, שם, תואר, מילית, מילה לועזית, שם פרטי ואחריהם תחיליות או סופיות, ראשי תיבות וקיצורים (שאינם מקבלים ציין בשל הסימן הנוסף [ -, "] המבדיל אותם מן ההומוגראפים שלפניהם). כך, לדוגמה, כתב 1 ( = <strong>כָּתַב</strong>), כתב 2 (=<strong>כְּתָב</strong>).

    חרגנו מסדר זה בכל מקום שנראה היה לנו שאחת המילים ההומוגראפיות שכיחה בלשון לאין שיעור מחברותיה (<strong>אָדָם</strong> 1 [= איש], לעומת <strong>אָדַם</strong> 2 [ = נהיה 

    <strong>אדום</strong>]), או שהפועל הוא גזור שם (<strong>חָלָב</strong> 1 [ = הנוזל] לעומת <strong>חָלַב</strong> 2 [ = עסק בחליבה]) וכד'.



</p>

<p>

    <span class="SubTitle2">ג. <a name="c">הצירופים</a><br />

        </span><br />

חשיבות יתרה יוחדה במילון זה לצירופי הלשון, לניבים ולביטויים שבשפה, לדרך רישומם, למיונם ולארגונם השיטתי במילון. המדיניות שהותוותה בעניין זה כוללת חידושים רבים לגבי הנהוג במילונאות העברית המסורתית. נביא כאן בקצרה את עיקרי הדברים, בעיקר את אלו הנוגעים למשתמש הכללי במילון.

    <br />

    <br />

    <strong>הצירופים הכלולים במילון</strong><br />

צירוף לשוני לעניין מילון זה הוא רצף של שתי מילים או יותר המהווה יחידה לקסיקוגראפית וסמנטית אחת המחייבת כניסה משל עצמה במילון בגלל אחת (או יותר) מהסיבות הבאות:<br />

1.	משמעות הצירוף אינה נגזרת באופן טבעי ממשמעויות רכיביו (<em><strong>פליטת פה</strong></em>,

    <strong><em>גילה את אוזנו</em></strong>, <strong><em>אף-על-פי</em></strong>).

    <br />

2.	שינוי הצירוף באחת הדרכים הבאות עשוי לבטל את מעמדו, להופכו לבלתי קביל או לשנות את משמעותו (הכוכבית בדוגמאות שלהלן מסמנת מבנה בלתי קביל או מבנה שחדל להיות צירוף):

    <br />

•	נטייה של רכיב אחד או יותר (תוך שינוי המין, המספר, הסמיכות, הכינויים וכד'): <em><strong>

        פשט את הרגל</strong></em> (*פשט את הרגליים), <strong><em>בעל יכולת</em></strong>

    (*בעלים של יכולת), <strong><em>מס שפתיים </em></strong>(*מס שפתיו).

    <br />

•	שינוי סדר הרכיבים: <strong><em>תוהו ובוהו</em></strong> (*בוהו ותוהו), <strong><em>בשר ודם</em></strong>

    (*דם ובשר).<br />

•	שיבוץ מילה נוספת בצירוף: <strong><em>אמר נואש</em></strong> (*אמר בלחש נואש), <strong><em>פגע וברח</em></strong> (*פגע באיש וברח).

    <br />

•	החלפת אחד הרכיבים במילה נרדפת או במילה שהיא לכאורה בעלת תפקיד דומה: <strong><em>הפיל תחנוניו</em></strong>

    (*הפיל תפילותיו), <strong><em>אחרית הימים</em></strong>(*אחרית השנים).

    <br />

3.	לצירוף מבנה דקדוקי חריג: <strong><em>גמולֵי מחלב</em></strong>, <strong><em>ממה נפשך</em></strong>,

    <strong><em>מלכת אסתר</em></strong>.

    <br />

4.	אחד מרכיבי הצירוף הוא 'מילת כֶּלַח', מילה שאין לה כיום קיום עצמאי בלשון והיא מופיעה רק בצירוף זה (או בצירופים קרובים) כגון המילים ' כֶּלַח', 'עוּל', ' שְׁאָט' שבצירופים אבד עליו הכלח, <strong><em>עול הימים</em></strong>, <strong><em>שאט נפש</em></strong>.

    <br />

5.	לצירוף תפקיד טרמינולוגי, והוא משמש כשם של בעל חיים (<strong><em>דוב לבן,</em></strong>

    <em><strong>סוסון ים</strong></em>) צמח (<em><strong>שיבולת שועל</strong></em>,

    <strong><em>תפוח אדמה</em></strong>), כלי, מכשיר, התקן וכד' (<em><strong>מדיח כלים</strong></em>,

    <em><strong>בורר ערוצים</strong></em>), מקצוע (<strong><em>רואה חשבון</em></strong>,

    <strong><em>עורך דין</em></strong>), מושג מופשט (<strong><em>הבנת הנקרא</em></strong>,

    <strong><em>טוהר הנשק</em></strong>) וכד'.<br />

6.	הצירוף הוא אמירה קפואה מקובלת בעלת תפקיד חברתי-קומוניקטיבי: <strong><em>במחילה מכבודך</em></strong>,

    <strong><em>דרך צלחה</em></strong>, <strong><em>בוקר טוב</em></strong>, <em><strong>

        מה נשמע</strong></em>.<br />

7.	הצירוף פותח בתחילית: <em><strong>חד-ערכי</strong></em>, <strong><em>בתר-תעשייתי</em></strong>,

    <strong><em>בין-גושי</em></strong>.

פועל ומילת ההצרכה שלו אינם מסווגים כצירוף, והם מופיעים עם ההסבר בערך המתאים.

ככלל, אין הצירופים במילוננו מסומנים במקף, גם לא צירופי סמיכות הדוקה, כגון  <strong><em>בית חולים</em></strong>,<strong><em> גן עדן</em></strong>,

    <strong><em>יפה נפש</em></strong>, <strong><em>תל אביב</em></strong>. סימון המקף יוחד רק לצירופים הפותחים בתחילית (<em><strong>דל-שומן</strong></em>, <strong><em>רב-מסלולי</em></strong>,

    <em><strong>על-קולי</strong></em> וכד'), צירופים שיש בהוראתם ציון של תחום ביניים או טווח (<strong><em>צפון-מזרח</em></strong>, <em><strong>קרקע-אוויר</strong></em>),

    צירופים הנכתבים גם כמילה אחת (<strong><em>כדור-סל</em></strong>), צירופי שמות אותיות שהם דרך הגייתם של ראשי תיבות אחדים (<strong><em>שין-גימל</em></strong>, <strong><em>

        אר-פי-ג'י</em></strong>) וכן שמות פרטיים של מקומות יישוב המהווים יחידה מִנהלית אחת (<strong><em>מעלות-תרשיחא</em></strong>, <em><strong>מכבים-רעות</strong></em>).

    <br />

    <br />

    <strong>חלופות מורפולוגיות לצירופים<br />

    </strong>

צירוף עשוי להופיע בחלופות מורפולוגיות שונות: שמנית (<strong><em>פשיטת רגל</em></strong>),

    פועלית (<strong><em>פשט את הרגל</em></strong>) או צורת סמיכות שהנסמך בה בינוני (<em><strong>פושט

        רגל</strong></em>). מכיוון שגזירתן של חלופות אלו אינה אוטומטית וקבועה מראש (<em><strong>רואה

            חשבון</strong></em>, <strong><em>ראיית חשבון</em></strong>, למשל, הם צירופים אך לא 'ראה חשבון'; <em><strong>היכה גלים</strong></em> הוא צירוף אך לא 'הכאת גלים'), מופיעות כל החלופות הללו במילון בצורה עצמאית ועם הביאור כנדרש.

    <br />

    <br />

    <strong>שינויי נוסח בצירופים<br />

    </strong>

מילה (או יותר) המופיעה בצירוף כשהיא מוקפת סוגריים עגולים היא מילה שניתן להוסיפה לצירוף או להשמיטה ממנו מבלי לפגוע במעמדו של הצירוף או במשמעותו: <strong><em>

        בנה מגדלים (פורחים) באוויר</em></strong>, <em><strong>דבר אל העצים (ואל האבנים)</strong></em>,

    <em><strong>הלך לו קלף (משוגע)</strong></em>.

מילה המופיעה בצירוף כשהיא מוקפת בסוגריים מרובעים, וכן סדרת מילים המופרדות בפסיקים המופיעות בתוך סוגריים כאלה, מציינות חלופות אפשריות למילה שלפני הסוגריים, חלופות שאינן משנות את מעמדו של הצירוף או את משמעותו: 

    <em><strong>חרת [כתב] על לוח ליבו</strong></em>, <strong><em>התפקע [התפוצץ, התגלגל] מצחוק</em></strong>, <strong><em>גזים אצילים [אִינֶרְטיים, אדישים, נדירים]</em></strong>.

אם קבוצת הבחירה היא רחבה יותר ומכילה יותר משלוש חלופות, יצוינו שתיים מהן בלבד ולאחריהן הציון 'וכד": <strong><em>קרא דרור ליצריו [לתשוקותיו, לדמיונו וכד']</em></strong>.

כשרכיב מרכיבי הצירוף עשוי להופיע בצורה נטויה (ריבוי, כינויים וכד') או בשינויי נוסח קלים אחרים, מצוין הדבר בהערה מפורשת כך: <strong><em>איבד את העשתונות</em></strong>

    (גם: איבד את עשתונותיו).

    <br />

    <br />

    <strong>



צירופי פועל שמשלימו מושא<br />

    </strong>הצירופים <strong><em>גילה את ליבו</em></strong>, <strong><em>היטה את ליבו</em></strong>

    נראים לכאורה בעלי מבנה זהה, ועם זאת יש למעשה הבדל סמנטי מכריע ביניהם. בצירוף הראשון פלוני גילה את ליבו (של עצמו), ואילו בשני פלוני היטה את ליבו של מישהו (אחר). במילוננו ציַינו הבחנה זו באופן שיטתי בהוסיפנו לצירופים מהסוג השני את המשלים המתאים (<strong><em>היטה

        את ליבו של מישהו</em></strong>, <strong><em>פרק את עולו של מישהו מעל צווארו, קרע את המסכה [המסווה] מעל פניו של מישהו).</em></strong>

    <br />

    <br />

    <strong>



מיקום הצירוף<br />

    </strong>

אחת השאלות המטרידות כל מילונאי היא קביעת מקומו של הצירוף עם ביאורו, כלומר תחת איזו מן המילים המרכיבות את הצירוף יש להציגו. רוב המילונים שקדמונו לא קבעו מסמרות בעניין זה ולא נמצאה בהם שיטה אחידה. נראה שלרוב נקבע הדבר על-פי קביעת המילה העיקרית וה"חזקה" שבכל צירוף וצירוף. קביעה זו נתונה פעמים רבות לשיקול דעתו של המילונאי ולא תמיד יכול המשתמש להתחקות על שיקול דעת זה.<br />

במילוננו נקטנו כלל ברור המעמיד את הצירוף עם ביאורו תחת <span>

        המילה הראשונה </span>שבו <a href="#Note11">(11)</a>. מכלל זה חרגנו רק כאשר <span>המילה הראשונה</span>

    היא אחת מן המיליות הנפוצות שיפורטו להלן, שאז יופיע הצירוף עם ביאורו לרוב תחת המילה השנייה (או השלישית) שבצירוף (<strong><em>מה אכפת לך</em></strong> תחת <strong><em>אכפת</em></strong>,

    <strong><em>מה זה עסקך</em></strong> תחת <strong><em>עסק</em></strong>). כך נהגנו גם במקצת מן הצירופים המתחילים בפעלים 'היה' ו'עשה' בגלל ריבוים. גם כאשר הצירוף פותח בתחילית יופיע הביאור תחת המילה השנייה (<strong><em>מד-זווית</em></strong> תחת <strong>

        <em>זווית</em></strong>), אלא אם כן אין למילה השנייה כניסה משל עצמה במילון (<strong><em>דו-אופני</em></strong>).

עם זאת אפשרנו למעיין להגיע אל הצירוף גם שלא דרך המילה הראשונה שבו, וזאת על-ידי פיתוח מנגנון של הפניות שיטתיות מכל רכיביו האחרים של הצירוף אל מקומו במילון שם הוא מתבאר. כך, למשל, מופיע הצירוף <strong><em>פת שחרית</em></strong> עם ביאורו תחת הערך <strong>

        <em>פת</em></strong>, אך המשתמש ימצאנו גם בערך <strong><em>שחרית</em></strong>,

    אולם שם בלי ביאור אלא עם הפניה אל הערך <strong><em>פת</em></strong>. הניב <strong><em>

        איבד את הידיים והרגליים</em></strong> מופיע עם ביאורו תחת <strong><em>איבד</em></strong>,

    אבל הוא מופיע גם תחת <strong><em>יד</em></strong> ותחת <strong><em>רגל</em></strong>

    עם הפניה אל <strong><em>איבד</em></strong>. אף אם הצירוף כולל מילה שאין הצדקה להכנסתה כערך עצמאי במילון, נפתחה עבור מילה זו כניסת הפניה מיוחדת המפנה למקומו של הצירוף המוסבר (<strong><em>קיבר</em></strong>&gt;&gt; <strong><em>פת קיבר</em></strong>;

    <strong><em>קולומבוס</em></strong> &gt;&gt; <strong><em>ביצת קולומבוס</em></strong>).

    <br />

    <br />



סידור חדש זה של הצירופים במילוננו מבטיח שהצירוף מתבאר במילון רק פעם אחת ובמקום המוגדר על-פי כללים פשוטים וחד-משמעיים; המשתמש עצמו פטור מלהכיר כללים אלה שהרי בכל מקרה הוא ימצא את הצירוף המבוקש, אם במקום שבו הוא מתבאר, אם תחת אחד מרכיביו האחרים המפנים אל מקום הביאור. עוד מבטיח סידור זה לסקור במבט אחד את כל הצירופים שבהם משתתף ערך כלשהו מערכי המילון, וגם זה הוא מן החידושים החשובים שהונהגו במילוננו.<br />

    <br />



המיליות הנפוצות המופיעות תדיר בצירופים ואין מהן הפניה לצירוף הן:

או, אין, אף, אם, את, ב, בין, בלי, זה, יש, כי, ל, לא, לפי, מה, מי, מן, עד, עוד, על, עם, של.

    <br />

    <br />



סוגים אחדים של צירופים הועמדו כערכים ראשיים לעצמם, ואינם מוזכרים תחת המילים המרכיבות אותם, ואלו הם:

    <br />

    • צירופים שבהם אין למילה הראשונה כניסה משל עצמה במילון (<em><strong>שאט נפש, עול ימים</strong></em>).

    <br />

•	צירופים שמניים (לרוב טרמינולוגיים) שבהם המילה הראשונה היא צורת בינוני, ואין לצורה זו מעמד שמני עצמאי במילון (<strong><em>חולץ פקקים, גורד שחקים</em></strong>) או שמשמעות הצירוף התרחקה סמנטית מזו של הערך בעל צורה זו (<strong><em>עורך דין</em></strong>).

    במקרים אלו ניתנה הפניה לצירופים האלה גם מן הפועל של צורת הבינוני שבהם (<strong><em>חלץ,

        ערך</em></strong>).

    <br />

•	שמות בעלי חיים שבהם המילה הראשונה אינה שמו של בעל חיים מאותה קבוצה זואולוגית (<em><strong>גמל

        שלמה, פרת משה רבנו</strong></em>).

    <br />

•	צירופים קפואים מארמית או משפה זרה כלשהי (<strong><em>לית מאן דפליג, קוריקולום ויטה</em></strong>),

    וכן כאלה הפותחים במילה שיהא גימטריה (<strong><em>תרי"ג מצוות</em></strong>) או שהם נפוצים בעיקר בצורת ראשי תיבות (<strong><em>דין וחשבון</em></strong> [דו"ח]).)

    <br />

    • צירופים שהם שמות פרטיים של מקומות (<strong><em>רמת גן</em></strong>), ארגונים

    (<strong><em>יד ושם</em></strong>), דמויות (<strong><em>דון ז'ואן</em></strong>),

    ספרים (<strong><em>דברי הימים</em></strong>), קטעי תפילה (<strong><em>מודה אני</em></strong>)

    וכד'.

    <br />

•	כל הצירופים מסוג זה באים במקומם האלפביתי על-פי המילה הראשונה הפותחת אותם (<strong><em>דוב

        ים</em></strong> יופיע לפיכך לפני <strong><em>דובאי</em></strong>, <strong><em>נר הלילה</em></strong>

    לפני <strong><em>נראה</em></strong>, וכיו"ב).

    <br />

    <br />

    <strong>





צרפים וניבים<br />

    </strong>

רישום אלפביתי שוטף של הצירופים המופיעים תחת ערך מסוים, הנהוג במילונאות העברית עד ימינו, מקבץ  יחד צירוף כ- <strong><em>חומר גלם</em></strong> עם הביטוי 

    <strong>כחומר ביד היוצר</strong>, דבר שראוי להימנע ממנו בשל אופיים השונה של צירופים אלו. לפיכך נקטנו במילון זה חלוקה של הצירופים לשתי קבוצות: צרפים וניבים. הראשונים מייצגים את הפרזיאולוגיה של השפה, והאחרונים – את האידיומאטיקה שלה.<br />

את ההבחנה בין צרפים לניבים תמכנו באופן עקרוני במבנה המורפולוגי של הצירוף. בקבוצת הצרפים כללנו את הצירופים שגרעינם הוא שֵם ובכלל זה צירופי סמיכות למיניהם (סמיכות רצופה וסמיכות מפורקת) בין שהנסמך הוא שם עצם בין שהוא תואר (<strong><em>אחוז חסימה, מוצא של כבוד, גבה קומה</em></strong>), צירופי שם ותואר מסוגים שונים (<em><strong>אנרגיה סולארית, הגירה יוצאת, טוראי ראשון</strong></em>), צירופי שם עם צירוף יחס (<strong><em>הנחה מראש</em></strong>),

    צירופי צמידות (<strong><em>נער שליח</em></strong>), צירופי שמות מספר הן בסמיכות והן בצמידות (<strong><em>עשרת הדיברות, עשרה בטלנים</em></strong>) וכן צירופים של

    שמות תואר עם תוארי פועל (<em><strong>סודי ביותר</strong></em>), עם שם פועל (<em><strong>נוח

        לרצות</strong></em>), או צירופים הפותחים בתחילית (<strong><em>חד-משמעי</em></strong>).

    לעומתם ראינו כניבים את הצירופים הפותחים בפועל (<em><strong>אמר נואש</strong></em>),

    במילית (<em><strong>מן המסד עד הטפחות, לדאבון ליבו</strong></em>), בשם עצם נטוי (<strong><em>תורתו אומנותו</em></strong>), וכן צירופים שהם בתבנית בִּינוֹם (<strong><em>יפה

        יפה</em></strong>) או הפלגה (<em><strong>קל שבקלים</strong></em>) וכן מיני אמירות (<em><strong>דרך צלחה</strong></em>) וכד'.

    <br />

פתגמים, שהם משפטים המנוסחים בלשון קצרה וחותכת והמביעים חוכמת חיים, הטפה להתנהגות מסוימת וכד', לא נכללו במילון, שכן בעצם טיבם אין הם יחידות לקסיקוגראפיות.  <a href="#Note12">(12)</a><br />

הניבים המופיעים עם ביאוריהם תחת ערך מסוים מופיעים בהמשך ישיר לאחר המשמעויות השונות של הערך. גוש הניבים פותח בשורה חדשה המסומנת באיקון O ויתר הניבים מופיעים אחריו ברצף.<br />

לאחר הניבים המוסברים מופיעה רשימת הניבים המכילים ערך זה הנמצאים עם ביאורם במקום אחר במילון.  מנגנון ההפניות הוא מדויק ופשוט: מקומו של הניב עם ביאורו הוא תחת המילה הראשונה המופיעה בהפניה (בדיוק ככתבה שם) או שהוא צירוף ראשי המופיע במקומו האלפביתי (שוב ככתבו). בכל מקרה אחר מופיע איקון הפניה >> ולאחריו המילה שתחתיה מופיע הניב עם ביאורו (<strong><em>ביאת המשיח</em></strong> &gt;&gt; <strong><em>ביאה</em></strong>).

גוש הצרפים המוסברים מופיע לאחר הניבים, כשכל צרף מתחיל בשורה חדשה. לאחר גוש זה מופיעה רשימת הצרפים שהסברם מופיע במקום אחר במילון. מנגנון ההפניה כאן זהה לזה של הניבים.<br />

כל אחד מארבעת הגושים הללו (ניבים מוסברים, ניבים מפנים, צרפים מוסברים וצרפים מפנים) ממוין מיון אלפבית פנימי מלא. <a href="#Note13">(13)</a><br />

    <br />

    <strong>חלקי דיבר בצרפים<br />

    </strong>

צרפים רבים משמשים בלשון כמושג אחד בעל תפקיד מורפולוגי ותחבירי מוגדר (ובמקרים רבים הם אף מיתרגמים לשפות אחרות כמילה אחת), כך שמבחינת תפקודם אין בינם לבין מילה אחת אלא סימן הרווח שבין הרכיבים בלבד. לפיכך צוינו במילוננו לרוב גם הצרפים בחלק הדיבר המתאים להם, ואף זה מן החידושים שהונהגו כאן. חלקי הדיבר שצוינו הם 'שֵם', 'תואר' ו'שם מספר' בלבד, ולגבי שם עצם צוינו גם המין (והמספר), כדרך שצוינו לגבי הערכים שהם מילה אחת. חלק הדיבר לא צוין לצירופים שהם שמות פרטיים (או כינויים לשמות פרטיים), כרגיל במילון זה שאינו מציין את חלק הדיבר של שמות פרטיים (ראה להלן, פרק ד).

    <br />

    <br />

    <strong>האפראט בצרפים</strong>

    <br />

צרפים שמנים ותואריים מקבלים צורות נקבה וריבוי לפי כללי דקדוק ידועים ומוגדרים בהתאם לרכיבי הצירוף. מכיוון שהאפראט של כל אחד מרכיבי הצירוף מפורט במקומו, לא ראינו בדרך כלל צורך לתת אפראט מיוחד לצירופים. עם זאת, במקרים מסוימים שבהם צורות הנקבה או הריבוי של הצירוף הן יוצאות דופן או בלתי ברורות מאליהן, או במקום שיש עניין בהצגת נטייתו של הצירוף, צוינו צורות אלה במפורש בהערת שימוש לפני הביאור: <strong><em>כיסא נוח</em></strong>

    (בריבוי: כסאות נוח), <strong><em>יישר כוח</em></strong> (בנטייה: יישר כוחך, יישר כוחו).





</p>

<p>

    <span class="SubTitle2">ד. <a name="d">חלקי דיבר</a></span><span><br />

        </span><br />חלק הדיבר (ח"ד) של הערך רשום מיד ובסמוך לערך עצמו. רשימת חלקי הדיבר ששימשה אותנו במילון מופיעה בעמודים שלפני מבוא זה,

    <a href="#Note14">(14)</a> וכאן נרחיב בהערות אחדות.

כרגיל נרשם לצד שמות עצם חלק הדיבר 'שֵם' בצירוף הציון למינו, אם זכר אם נקבה (ז', נ'; <strong><em>שולחן</em></strong>

    שם ז'; <strong><em>ביצה</em></strong> שם נ').<br />

ציון המספר ('יחיד' וכד') אינו מופיע אלא במקום שהעיול הוא בריבוי (<strong><em>טרשים</em></strong>,

    שם ז"ר), ומכאן למֵד  המעיין, שהשֵם שעיולו הוא צורת יחיד גוזר כרגיל צורת ריבוי (את צורת הריבוי עצמה הוא ימצא באפראט הדקדוקי). נקטנו עיקרון זה גם באשר לשמות עצם שיש בהם צורת זכר ונקבה (<strong><em>פקיד</em></strong>, <strong><em>חייל</em></strong>)

    ורשמנו בהם רק 'שֵם' תוך השמטת ציון המין. מכאן יבין המשתמש שציון ח"ד 'שֵם' ליד ערך כלשהו מורה על קיומה של צורת נקבה לשם זה, בעוד שציון 'שם ז" או 'שם נ" מורה על כך שאין השם גוזר צורה מן המין האחר.

    <br />

לקבוצות הערכים המפורטות להלן לא צוין ח"ד:<br />

    • ערכים בצורות נטויות (<strong><em>לי, ממנו, בעטיו, חושבני</em></strong>).<a href="#Note15">(15)</a>

    <br />

•	ערכי הפניה (למעט הפניה ממילה עברית למילה לועזית או להיפך).

    <br />

•	ערכים עבריים ללא גוף, מין ומספר ושאין לייחס להם ח"ד מתאים מתוך הרשימה שנקבעה (<em><strong>אפשר,

        אכפת, חֲבָל</strong></em>) ערכים לועזיים מסוג דומה (<strong><em>אנטי, אָאוּט, אַפְּרוֹפּוֹ</em></strong>),

    וקבוצה מצומצמת של מילים ארמיות (<strong><em>תיקו, זוטא, קשיא</em></strong>).

    <br />

•	קיצורים (<strong><em>וכו'</em></strong>), ראשי תיבות (<strong><em>אח"כ</em></strong>)

    וערכים דמויי ראשי תיבות (<strong><em>האמנתי"ו</em></strong>). אם ערך שהוא ראשי תיבות משמש כשם או כתואר (<strong><em>רמטכ"ל</em></strong>) צוין הדבר בהערת שימוש בתחילת ההסבר.

    <br />

•	שמות פרטיים של אדם, דמות, מקום, מדינה, יצירה, שמות אותיות בשפות השונות וכד' או כינויים של שמות כאלה.<br />

כן לא צוינו חלקי דיבר לערכי משנה, למעט מקרים שבהם הם משמשים בתפקיד דקדוקי שונה מזה של הערך הראשי.<br />

חלקי הדיבר צוינו גם לגבי צירופים מסוימים, וראה על כך לעיל, בפרק ג.

</p>

<p>

<span class="SubTitle2">ה. <a name="e">משלבים</a></span><br />

        <br />

    תשומת לב מיוחדת הוקדשה במילוננו להגדרת משלב הלשון שבו משמשת הוראה כלשהי מהוראות

    המילה או הצירוף, וראינו בכך ערך רב לחידוד ההוראה ולהעמדתה במקומה הראוי. יודגש שהמשלב

    הוא ציון להוראה ולא לערך, וכל הוראה מהוראות הערך שאינה "רגילה" או ניטראלית קיבלה

    את ציון המשלב הראוי לה. כך, למשל, המעיין בערך <strong><em>נא</em></strong> ימצא

    בהוראה 1 את המשמעות הניטראלית של מילת נימוס, וזו אינה מצוינת במשלב כלשהו, בעוד שבהוראה

    2 המוגדרת 'מליצית' מוצגת המשמעות של לשון הבקשה והתחינה. כן גם בערך <strong><em>חתיכה</em></strong>

    – הוראה 1 היא ללא משלב בעוד שהוראות 2, 3 מאופיינות במשלב 'בלשון הדיבור', וראה גם

    בערך <strong><em>פִסְפוּס</em></strong>, שם כל ההוראות מצוינות

    – כל אחת לעצמה – במשלב 'בלשון הדיבור'. הגדרנו שמונה משלבים עיקריים – ארבעה "גבוהים"

    וארבעה "נמוכים".

    <br />

    המשלבים הגבוהים הם:

    <br />

    (א) 'ספרותית' – מילים וצירופים המשמשים בעיקר בכתיבה של ספרות יפה או בכתיבה המחקה

    אותה (<strong><em>ארי</em></strong>);

    <br />

    (ב) 'מליצית' – מילים שיש בהן עלייה מודעת כלפי מעלה תוך חיקוי המצוי במקורות קדומים

    של הלשון או מתוך קונוטציה ברורה אליהם (<strong><em>לא שזפתו עין</em></strong>);

    <br />

    (ג) 'למדנית' – מילים, צירופים וצורות לשון שהמשתמש בהן מחקה בבירור את המצוי במקורות,

    כגון בספרות חז"ל ובספרות הפילוסופית של ימי הביניים (<strong><em>דא עקא</em></strong>);

    <br />

    (ד) 'פורמלית' – מילים וצירופים המשמשים בלשון המשרדית-פורמאלית (כגון בפקודות צבא,

    פוליסות ביטוח, חוזים וכד'), כשלעומתן משמשות בלשון הכתיבה והדיבור הרגילה מילים אחרות

    (<strong><em>מושכר</em></strong> שם ז' [=נכס שנמסר בהשכרה]).

    <br />

    המשלבים הנמוכים הם:

    <br />

    (א) 'בלשון הדיבור' – מילים וצירופים המשמשים בלשון הדבוּרה בלבד ואינם נכללים בלשון

    ה כ ת ו ב ה של אדם משכיל אלא מומרים בה במילה אחרת <strong><em>בָּלָטָה</em></strong>

    [מרצפת], <strong><em>טוש</em></strong> [מקלחת]);

    <br />

    (ב) 'סלנג' – מילים וצורות לשון תת-תקניות שהמשתמש בהן עושה זאת מתוך הכרה ובחירה ומתוך

    ידיעה שהוא משתמש במילה שיש לה בלשון חלופה תקנית (<strong><em>הסתלבט, חפיף</em></strong>).

    השימוש בסלנג משייך

    את הדובר (או את הדברים הנאמרים) להקשר חברתי מסוים, וכאשר התנאים לשימוש בסלנג אינם

    מתאימים, ממיר הדובר עצמו את הסלנג בצורה תקנית חלופית;

    <br />

    (ג) 'המונית' – מילים של לשון בוטה, שבהקפדה על לשון נקייה נוטים להימנע מהן ולהמירן

    באחרות (<strong><em>חולירע</em></strong>[ככינוי גנאי], <strong><em>זנזונת, מספר</em></strong>

    [=משגל]);

    <br />

    (ד) 'המונית גסה' – מילים שההמוניות בהן היא קיצונית, לרוב מילות סלנג מתחום המין והפעילות

    המינית וכן קללות וגידופים שניבול הפה בהן הוא קיצוני (<strong><em>חרא</em></strong>).

    <br />

    <br />

    בנוסף למשלבים העיקריים הנ"ל, הרבינו בציון אפיונים המתייחסים לאופי ולמקום שבהם המילה

    או אחת מהוראותיה משמשות. כך, למשל, הציון 'בלשון המקרא' מעיד שהמילה או הוראה מסוימת

    של המילה משמשים בטקסט הכתוב בלשון המקרא או בטקסט המבקש לחקות לשון זו. המילון כולל

    למעלה מעשרים אפיונים כאלה וביניהם: בלשון המקרא (<strong><em>היגיון</em></strong>

    הוראה 7, <strong><em>הלזו</em></strong>), בלשון חז"ל (<strong><em>היאך, הגמון</em></strong>

    הוראה 2, <strong><em>נַקבוּת</em></strong>), בלשון הרבנית (<strong><em>פִּרכה</em></strong>),

    בלשון הפיוט (<strong><em>אימה</em></strong> הוראה 2), בלשון ימי הביניים (<strong><em>חזנות</em></strong>

    הוראה 3) ועוד. יודגש שאין בציון האפיון כל כוונה לומר דבר

    על הרובד הלשוני שבו מתחילה המילה את חייה בתולדות הלשון העברית, שכן סוג כזה של אינפורמציה

    לא הוכנס כלל למילוננו.

</p>

<p>

    <span class="SubTitle2">ו. <a name="f">תחומים</a></span><br />

        <br />

    מילים וצירופים המיוחדים לתחום מסוים, או שאחת מהוראותיהם מיוחדת לתחום מסוים, קיבלו

    את ציון התחום באותיות אפורות בתחילת ההסבר. השתדלנו להרבות בציונים ספציפיים אלו ולדייק

    בהם, והגענו עד למגוון של עשרות רבות של תחומים שונים מכל שטחי המדע והחיים וביניהם:

    <br />

    מתמטיקה, בוטניקה, זואולוגיה, כימיה, פיזיקה, רוקחות, חשמל, חקלאות, צילום, בנייה,

    סוציולוגיה, גיאוגרפיה, מחשבים, בלשנות, משפטים, כלכלה, בנקאות, ביטוח, תחבורה, מיתולוגיה

    יוונית, שחמט, משחקי כדור, אדריכלות, אופנה ולבוש, ספנות, בישול ואפייה, צבא ומשטרה

    ועוד ועוד. כל התחומים הללו מצוינים בלשון המציגה את התחום עצמו בלא אות השימוש 'ב'

    ('מתמטיקה' ולא 'במתמטיקה').

    <br />

    ציון התחום לא בא בערך ששיוכו לתחום מובן מאליו (כגון 'בוטניקה' בשמות של צמחים). לעומת

    זאת הקפדנו על ציונים כאלה במיוחד כאשר יש למילה הוראות שונות המתייחסות לתחומים נבדלים.

    <br />

    סוג אחר של ציון תחומה של המילה או הצירוף (או הוראה מסוימת בהם) הוא הציון הבא בסוגריים

    בתחילת ההוראה והבא לתחם מבחינת הזמן, המקום, החברה, הדת, סוג הספרות וכד', כגון: בגרמניה

    הנאצית (<strong><em>פלוגת הסער</em></strong>), בפולקלור האנגלי (<strong><em>אבירי השולחן

        העגול</em></strong>), בכנסייה הקתולית (תא וידוי), בפוליטיקה הישראלית (<strong><em>נסיך</em></strong>

    הוראה 4), בדיון התלמודי (<strong><em>ודין הוא</em></strong>), בדיני אישות (<strong><em>שארה

        כסותה ועונתה</em></strong>), באגדות חז"ל (<strong><em>מלחמת גוג ומגוג</em></strong>),

    בפילוסופיה של קאנט (<strong><em>פנומנון</em></strong>) ועוד ועוד – מגוון של כשבעים

    ציונים שונים.</p>

<p>

    <span class="SubTitle2">ז. <a name="g">הערות אטימולוגיות</a></span><br />

       <br />

    ככלל, לא מסרנו במילון מידע מלא ושיטתי באשר לאטימולוגיה של המילים (במובנו הקלאסי של מונח זה), מוצאן, קשריהן עם מילים מקבילות או קרובות בלשונות שמיות או אחרות. בציון אטימולוגיה של מילה עברית מקראית כלשהי יש מטבע הדברים צורך לציין קשר לשפות שמיות כגון אכדית, פיניקית, אוגריתית וכיו"ב ואף לשפות שאינן שמיות כגון מצרית, חיתית ועוד, ציונים שהם כספר החתום לרוב משתמשי המילון (למעט חוקרי הלשון  המובהקים שבהם); מידע זה, ככל שיהיה חשוב לחשיפת מקורותיה של העברית, אין בו אפוא תועלת של ממש עבור המשתמש המצוי. המקרא הוא ערש הלשון העברית, ומילה המופיעה בו (למעט בפרקים אחדים בספרים דניאל ועזרא הכתובים ארמית) או הנגזרת ממילה המופיעה בו, היא, בפשטות, עברית; ההזדקקות למקורותיה ולהשוואתה ללשונות אחיות וקרובות עשויה להיראות במילון כשלנו הפגנת למדנות שאינה במקומה.<br />

מאידך השתדלנו להעשיר את מילוננו במידע אטימולוגי מגוון באשר למילים <span>

        שמקורן לועזי</span>, וכן באשר <span>לניבים וביטויים</span>

    שמקורם במקרא או בלשון חז"ל, מילים וצרפים <span>שמקורם

        בשמות פרטיים</span> למיניהם ועוד. במקרים כאלה אף הרחבנו לעיתים את היריעה מעט כדי למסור מדי פעם מידע העשוי לעניין או להפתיע את הקורא.

    <br />

    <br />

    <strong>הערות למקור המילים<br />

    </strong>

הערות אטימולוגיות למקורה של המילה נרשמו במילון זה בהתאם לכללים אלה:

    <br />

    <br />

•	מילה שמקורה בלשון חז"ל ואליה היא הגיעה מן היוונית והלטינית (ובמקרים בודדים משפות אחרות, כגון הפרסית) צוינה בהערה מתאימה. אם משמעותה או צורתה המקורית היו שונות מאלה הנפוצות כיום, צוין הדבר במפורש בהערה. לדוגמה: <strong><em>בימה</em></strong> [מיוונית, דרך לשון חז"ל], <strong><em>דפוס</em></strong> [מיוונית, דרך לשון חז"ל, ושם 'תבנית'], 

    <strong><em>גרדום</em></strong> [מלטינית, דרך לשון חז"ל, ושם הבמה שעליה היו דנים באימפריה הרומית דיני נפשות], <strong><em>סיטונאי</em></strong> [מיוונית, דרך לשון חז"ל, ושם הצורה 'סיטון'].<br />

    <br />

•	לגבי מילה שחדרה לעברית משפה זרה ידועה, צוינה השפה במפורש, וברוב המקרים ניתן גם כתיבה של המילה באותה שפה (<strong><em>מאסטרו</em></strong> [איטלקית maestro]). אם קיים ריחוק מסוים (במשמעות או בהגייה) בין הגלגול העברי למקורו הלועזי, צוינה השפה בתוספת 'מ' (<strong><em>קומודה</em></strong> [מצרפתית commode]). כתיב המילה בשפה המקורית ניתן רק אם אותה שפה היא אחת השפות הנפוצות כיום ושכתבן הוא כתב לטיני (אנגלית, צרפתית, איטלקית, ספרדית וכו'). באופן יוצא מן הכלל צוין הכתיב הלועזי מדי פעם גם באשר למילים לטיניות, וזאת כאשר המילה שומרת על צלילה הלטיני המקורי האופייני (<strong><em>אודיטוריום</em></strong>

    [לטינית auditorium]) או שקריאתה בגלגולה העברי קשה (<strong><em>אינדיבידואום</em></strong>

    [לטינית individuum]). אם משמעותה של המילה בשפת המקור שונה מזו המשתמעת מההסבר, צוינה גם משמעות זו במפורש בהערה (<strong><em>אגב</em></strong> [מארמית, 'על גבי']). בדרך כלל אין לנו עניין בגלגולי האטימולוגיה של מילה שחדרה לעברית משפה זרה ובתיאור דרכי חדירתה של המילה לשפה זו עצמה (שהרי דבר זה הוא לכל היותר עניינו של מילון שבאותה שפה ולא של מילון עברי, ובוודאי לא של מילון זה). עם זאת, ובמקרים ספורים בלבד, צוין מקורה הקדום יותר של המילה אם יש בו צד של הפתעה או של עניין מיוחד (<strong><em>מונוסון</em></strong>

    [מערבית, דרך פורטוגזית];  <strong><em>קפה</em></strong> [מערבית, דרך טורקית ואיטלקית]).

    <br />

    <br />

•	מילה שחדרה מן הלועזית בדורות האחרונים והיא משותפת למספר שפות זרות בגלל בסיסה היווני-לטיני (כגון <strong><em>פונקציה, מוזיקה, מטריצה</em></strong>) צוינה בהערה 'מלועזית' וללא כתיב לועזי כלשהו.

    <br />

    <br />

•	מילה שמקורה בשם פרטי (שם אדם, מקום וכד') או שחדרה לשפה דרך שמו של מוצר מסחרי וכד' צוינה בהערה מתאימה, לדוגמה: <strong><em>גיליוטינה</em></strong> [על שם ממציא המתקן, הפיזיקאי הצרפתי ז'וזף גיליוטין שחי בתקופת המהפכה הצרפתית]; <strong><em>קוניאק</em></strong>

    [על שם העיר קוניאק בדרום-מערב צרפת, הידועה בייצור המשקה]; <strong><em>וספה</em></strong>

    ['צרעה', על-פי שמו של קטנוע מתוצרת איטליה שהיה נפוץ בארץ בשנות השישים].

    <br />

    <br />



הערות אטימולוגיות אלו נרשמו לרוב רק לגבי הערכים שהם ראשי משפחה (על משפחות המילים ראה להלן בפרק יב).(16) בערך שהוא חבר משפחה ויש מקום להעיר עליו דבר מה מבחינה אטימולוגית, נוסף איקון מיוחד ופירושו שיש לפנות אל ראש המשפחה ולהשליך מן ההערה האטימולוגית שנרשמה שם גם לערך זה. כך, למשל, בסוף הערך דמוקרטי תופיע הפניה לראש המשפחה <strong><em>דמוקרטיה</em></strong>,

    וכך בערך <strong><em>הדפיס</em></strong> שראש משפחתו <strong><em>דפוס</em></strong>.

    <br />

    <br />

    <strong>הלחמים</strong>

    <br />

במילה עברית או לועזית המורכבת מצירוף של שתי מילים שכל אחת מהן מופיעה ומוסברת במקומה במילון, צוין ההלחם ללא הסבר נוסף וללא הבחנה בין צירוף מילים לבין 'הלחם אמיתי' (שהרי הדבר משתמע מצורת ההלחם). לדוגמא: <strong><em>רכבל</em></strong> [רכבל+כבל], <strong>

        <em>עדליון</em></strong> [עדי+תליון], <strong><em>הושענא</em></strong> [הושע+נא], 

    <strong><em>חוששני</em></strong> [חושש+אני], <strong><em>עדלידע</em></strong> [עד+דלא+ידע].

לרוב גם לא סומנו האותיות שנשמטו כתוצאה מההלחם אלא אם כן הן הושמטו מסופו של ההלחם או שמדובר בקטעי מילים שיש עניין בשחזורן, לדוגמה: <strong><em>מדחן</em></strong>

    [מד-+חנ(יה)], <strong><em>אקסטרפולציה</em></strong> [אקסטרה-+(אינטר(פולציה)], <strong>

        <em>אוטובוס</em></strong> [אוטו(מוביל)+(אומני)בוס].

אם אחד מרכיבי ההלחם הוא תחילית או סופית המופיעה כערך במילון, צוין הדבר על-ידי מקף המופיע בסופה של התחילית או בתחילתה של הסופית (בהתאמה): <strong><em>קולנוע</em></strong> [קול+-נוע], <strong>

        <em>אלקטרומגנט</em></strong> [אלקטרו-+מגנט], <strong><em>היסטוריוגראפי</em></strong>

    [היסטוריה+-גראפי], <strong><em>גיאולוגיה</em></strong> [גיאו-+-לוגיה].

    <br />

    <br />



אם אחד הרכיבים (בהכרח רכיב שאינו עברי) אינו מופיע במילון, יופיע בהלחם תרגומו לעברית תוך ציון שפת המקור (ולעיתים, על-פי הצורך, גם בתוספת מילת הסבר כלשהי), באופן הבא: 

    <strong><em>טלוויזיה</em></strong> [טל-+-וויזיה (=ראייה, מלטינית)], <strong><em>אנדרואיד</em></strong>

    [אנדרו (=גבר, אדם, מיוונית)+-ואיד (=דימוי, מיוונית)], <strong><em>עבדקן</em></strong>

    [עב+דקן (=זקן, מארמית)].

אם המילה היא הלחם כבר במקורה הלועזי, תצוין השפה בנפרד: 

    <strong><em>אנדרוגינוס</em></strong> [מיוונית, דרך לשון חז"ל, אנדרו (=גבר)+גינוס (=אישה)].

הלחם שאין שני רכיביו מצויים במילון יצוין בהערה מתאימה רק בערך שהוא ראש משפחה.<a href="#Note16">(16)</a> בשאר חברי המשפחה הסתפקנו בהפניה לראש משפחה תוך הוספת האיקון המתאים, כפי שנקטנו בכלל ההערות האטימולוגיות. כך, למשל, בערכים <strong><em>קולנוען, טלוויזיוני</em></strong>

    לא תופיע הערת הלחם, אבל להפניה לראש המשפחה (קולנוע, טלוויזיה, בהתאמה) המופיעה בסופם הוצמד האיקון הרומז על קיומן של הערות כאלה שם. הלחמים צוינו גם לשמות מסחריים (<strong><em>פלדלת</em></strong>

    [פלדה+דלת] ואף לערכי סלנג (<strong><em>שישבת</em></strong> [שישי+שבת]).

    <br />

    <br />

    <strong>הערות למקור הצירופים</strong><br />

ברישום הערות למקורם של הצירופים ננקטו הכללים האלה:

    <br />

•	לצירוף שמקורו במקרא או בספרות חז"ל הובא לרוב המקור המתאים בצירוף מובאה ("על-פי..."), ואם הדבר נדרש הובאו גם דברי רקע על מקורו של הצירוף (ראה<strong><em> ברחל בתך הקטנה</em></strong>).

    אם יש מרחק ניכר בין שימושו של הצירוף כיום לבין שימושו במקור המקראי או זה שבספרות חז"ל הובאה המובאה בלשון "על יסוד..." במקום "על-פי..." (ראה <strong><em>בטל בשישים</em></strong>).

    לשון זו ננקטה אף במקומות שפירושו של הצירוף במקורו אינו ברור כל צורכו (<strong><em>הילל

        בן שחר</em></strong>) וכן הוער על צירוף שבמקורו אין הוא צירוף כלל (<strong><em>צדיק

            תמים</em></strong>). לעיתים נדירות אף רמזנו למקור המקראי של מ י ל ה  (ולא של צירוף), וזאת במקרים של מילה בעלת מבנה זר או חריג והיא יחידאית או כמעט יחידאית במקרא (<strong><em>בסך, הכצעקתה</em></strong>).

    <br />

•	צירופים עבריים שהם תרגומי שאילה משפות אחרות לא צוינו בהערה מתאימה.

    <br />

•	לצירוף שרכיביו לועזיים והם  מופיעים כערכים במילון (<strong><em>אנרגיה סולארית</em></strong>)

    לא צוינה הערה אטימולוגית כלשהי, שהרי הקורא ימצא את המידע הנחוץ בערכי הרכיבים עצמם.

    <br />

•	צירוף שחדר לעברית כצורתו משפה אחרת תוך שימור היגויו ומשמעותו בשפת המקור (ואין לרכיביו קיום עצמאי בעברית) צוינה לגביו שפת המקור, וכן נרשם הכתיב המקורי ואף ניתן לו תרגום מילולי (<strong><em>מרא דאתרא</em></strong> [ארמית, 'אדון (רב) המקום'], 

    <strong><em>נומרוס קלאוזוס</em></strong> [לטינית, numerus clauses, 'מספר מוגבל']).

    <br />

•	לצירוף המכיל שם אדם או שם מקום ניתנה הערה ביוגראפית או גיאוגראפית קצרה (ראה <strong>

        <em>ביצת קולומבוס, אפקט דופלר</em></strong>).





</p>

<p>

    <span class="SubTitle2">ח. <a name="h">הערות הנחיה</a><br />

    </span><br />

       מילוננו כולל מגוון רחב של הערות שנועדו לשרת את המעיין ולהדריכו בדבר

    שימושו של ערך מסוים כפי שהוא מקובל בלשון. הערות מסוג זה, המופיעות בסוגריים עגולים

    בתחילת הביאור או בתחילת הוראה מסוימת בו, ניתנו בכל מקום שמצאנו לנכון להעיר על שימוש

    חריג שהמעיין אינו יכול לעמוד עליו מעצמו, והן כוללות סוגים שונים כמפורט להלן:<br />

    1. הערות שימוש – הערות העוסקות בשימושו המיוחד של הערך מבחינה מורפולוגית או תחבירית.

    במסגרת הערות אלו צוינו הגבלות שונות בנטייתו של הערך, כגון פעלים המשמשים בזמנים מסוימים

    דווקא ולא בזמנים אחרים (חשה – משמש בעיקר בצורות העתיד והמקור; יטב – משמש רק בצורות

    העתיד; בעבר ובבינוני משמש הפועל 'טוב'), שמות ששימושם הרווח אינו דווקא כצורת הערך

    ביחיד (גליד – בעיקר בריבוי נסמך: גלידי; פּוֹשֵׁט – בעיקר בריבוי: פּוֹשְׁטִים; בלעדֵי

    – לרוב בנטייה) וכיו"ב. כן הוספנו הערות הקשורות למין הדקדוקי (דרך – במקורות גם זכר;

    קולגה – משמש גם לנקבה), הערות לצורת נקבה מקבילה שיוחד לה ערך במילון (חתול – צורת

    הנקבה: חתולה), הערות המציינות את צורתו המורפולוגית של הערך (צֵאת – שם הפועל של יָצָא)

    והערות הקשורות להתנהגותו התחבירית של הערך (בן 2 [בֶּן ] – לפני מספר מונה).<br />

    2. הערות הגייה – הערות המציינות במפורש הגייה כלשהי של הערך אם כדי להבדילו מערך הומונימי

    שהגייתו שונה (בירה 1 =[עיר בירה] – במלרע; <strong><em>טבו</em></strong> 2 - במלרע),

    אם כדי להדגיש את הגייתו התקנית (כובע – ההגייה התקנית במלרע), ואם כדי לציין הגייה

    השונה מן הצורה המנוקדת (גלאט כשר – נֶהגֶה: כושר, במלעיל). במסגרת זו צוינו גם חלופות

    הגייה ובמקום הצורך ניתנה רמיזה לתקניות או לאי-תקניות שלהן כגון: <strong><em>דֶּלְפֵּק</em></strong>

    – נֶהגֶה גם דָּלְפק; <strong><em>מובטְחַני</em></strong> – יש הוגים: מובטַחְנִי;

    <strong><em>תֶּרְמוֹס</em></strong> – רווחת גם ההגייה תֶּרמוּס; <strong><em>חַלְבּן</em></strong>

    – ההגייה התקנית: חַלְבָן; <strong><em>גִּינֶקוֹלוֹג</em></strong> – רווחת ההגייה

    שלא כדין: גֶּנִיקוֹלוֹג. במקום שהווי"ו הגויה כחצי תנועה (כ – W אנגלית) צוין הדבר

    במפורש, כגון במילים <strong><em>ויסקי</em></strong>, <strong><em>ואללה</em></strong>

    ועוד.

    <br />

    3. הערות חלופה – מגוון רחב של הערות המציינות חלופות של כתיב ותצורה. נדגים כאן אחדות

    מהן :

    <br />

    • חלופות כתיב: <strong><em>וְכוּלֵי</em></strong> - נכתב גם: וכוליה; <strong><em>שִׁיקְסֶה</em></strong>

    – נמצא גם הכתיב: שיקסע, ובספרות גם: שקצה; <strong><em>חברמן</em></strong> – נמצאים

    גם הכתיבים: חברהמן, חברה'מן; <strong><em>ג"נ</em></strong> – נכתב לרוב שלא כדין:

    ג.נ.&nbsp; – ההגייה התקנית: חַלְבָן; גִּינֶקוֹלוֹג –

    רווחת ההגייה שלא כדין: גֶּנִיקוֹלוֹג. במקום שהווי"ו הגויה כחצי תנועה (כ – W אנגלית)

    צוין הדבר במפורש, כגון במילים ויסקי, ואללה ועוד. 3. הערות חלופה – מגוון רחב של הערות

    המציינות חלופות של כתיב ותצורה. נדגים כאן אחדות מהן :

    <br />

    • חלופות ניקוד: <strong><em>שְׁפָכִים</em></strong> – גם שׁוֹפְכִין; נמצא גם הניקוד:

    שֶּפָכִים ובהגייה: שוֹפָכִים; <strong><em>גבנוני</em></strong> – נמצא גם הניקוד

    גַּבְנֻנִּי.

    <br />

    • חלופות צורה: <strong><em>עַמְלָה</em></strong> – גם עֲמָלָהּ; <strong><em>יוּרוֹ</em></strong>-

    מופיע גם בצורה: אֵירוֹ-; <strong><em>גליצרין</em></strong> הצורה התקנית – גליצרול.

    <br />

    4. הערות הקשר – הערות המיועדות להבהיר בצורה מובחנת ומדויקת את ההקשר שבו משתמשים

    במילה בהוראה כלשהי. כך, למשל, ימצא המעיין בערך <strong><em>תלותי</em></strong> את

    הביאור כשהוא פותח במילים: '(נאמר על אדם או על התנהגותו)/ וכן: <strong><em>מדוגם</em></strong>

    '(נאמר על אריג או סריג)'; <em><strong>טָבוּל</strong></em> '(נאמר על תבואה או פרי)';

    <strong><em>הושכן</em></strong> '(נאמר על שלום)'; קוֹלֶקְט '(נאמר על שיחת טלפון)';

    רוּבִּי '(נאמר על שיטת בחירות)'; <strong><em>ננצר</em></strong> '(נאמר על כלי נשק)'

    ועוד ועוד, מאות רבות של הערות מסוג זה. ערך מיוחד יש להערות אלו לחידוד הוראותיה השונות

    של המילה. כך, למשל, ימצא המעיין בערך <strong><em>חבוש</em></strong> בהוראה 2: 'א.

    (כשנאמר על כיסוי ראש, כובע, מגבעת וכד') מונח על הראש. ב. (כשנאמר על אדם) שיש לו

    כובע...על ראשו', ובהוראה 3: '(כשנאמר על סוס, חמור וכד') ששמו עליו אוכף...'.





</p><p>

    <span class="SubTitle2">ט. <a name="i">הביאור</a><br />

    </span><br />

        עיקרו של המילון הוא כמובן ביאור הערכים. מטרתו של הביאור במילון זה היא,

    כפשוטו, להסביר את הערך תוך מתן הוראותיו השונות בהקשרים הלשוניים שבהם הוא עשוי להופיע,

    ולאו דווקא ל ה ג ד י ר ו (במובן אריסטוטֶלי של מושג זה). מכאן שנמנענו ככל האפשר מלבאר

    את המילה<br />

    במילה אחרת, נרדפת או בעלת משמעות דומה, ובוודאי שלא באמצעות מילה קשה יותר

    (יוצאים מכלל זה, כמובן, כמה מאות ערכים 'בסיסיים' כגון <strong><em>מים</em></strong>,<strong><em>

        רוח<br />

    </em></strong> ודומיהם שמשמעותם העיקרית היא מיידית ומוכרת לכול, ואין כמעט

    אפשרות לבארם במילים 'פשוטות' יותר).<br />

    נקטנו לשון פשוטה ובהירה העשויה לרוב כעין משפט,

    ועם זאת מדויקת דייה כדי לתחום באופן נכון את גדרי הוראותיו של הערך. נתַנו דעתנו במיוחד

    למגוון משמעויות 

    <br />

    הערך ולדקויותיו, ואת אלה פרשׂנו בפני המעיין בפירוט רב ובחלוקה מספרית

    להוראות (ראה למשל הערכים <strong><em>בובה</em></strong>, <strong><em>חם</em></strong>

    1). 

    <br />

    במקרה של הבחנה דקה ערכנו חלוקת משנה בתוך ההוראה המסומנת במספור אלפביתי (ראה,

    למשל, הערכים <strong><em>עמוד</em></strong> הוראה 5, <strong><em>חבוש</em></strong>

    הוראה 2).<br />

    במקום שההבחנה דקה עוד יותר עד שאין צידוק לפיצול לשתי הוראות נבדלות נתַנו

    נקודה ופסיק בתוך ההוראה ואף השתדלנו לתת דוגמאות לכל ההוראות המובחנות בדרך זו ובהתאמה,

    לפי סדר הופעתן של הוראות אלו. את כל אחת מן ההוראות ראינו כעומדת לעצמה וכמציינת את

    אחת ממשמעויותיה של המילה המתוארת, ועל כן נמענו מלציין הוראה כלשהי בציון 'בהשאלה'

    (שכן גם המשמעות ה'מושאלת' משמעות היא, אחת מהוראותיה של המילה).<br />

    סדר ההוראות בתוך

    הערך נקבע על יסוד שכיחותן בעברית בת-זמננו ומשום כך אין בו, כמובן, כדי להעיד על התפתחות

    היסטורית כלשהי. הוראה שאינה שכיחה ביותר או שהיא מתוחמת לתחום מסוים מוצאת את מקומה

    לאחר הוראה השכיחה ממנה או המצויה יותר בשימוש הכללי. כן גם באשר להוראות הפותחות בציון

    הקשרי המילה והמודפסים באות מובלטת (כמוסבר מייד להלן) ואף באשר להוראות שמן המשלבים

    הנמוכים (סלנג, המונית וכיו"ב). הוראה מהוראות המילה שאינה מקוימת עוד בעברית בת-זמננו

    לא מצאה את ביטויה במילון כלל. כך, למשל, לא הובאו בערך <strong><em>בזבז</em></strong>

    ההוראות 'בזז', 'חטף' וכן 'הביא עצמו לידי בוז וזלזול', המצויות בספרות התלמודית בלבד

    (וגם שם אין הן רגילות) ובלשון ימינו לא נתקיימו כלל.<br />

    במקום שהמשמעות מתייחדת להופעתו

    של הערך בהקשר תחבירי מסוים או בצורה מסוימת, התחלנו את הביאור בכניסת משנֶה המודפסת

    באותיות אדומות<a href="#Note17">(17)</a> והמתייחסת לצורתו של הערך או להקשרו במשמעות המסוימת. כך, למשל,

    בערך <strong><em>פָּעַל</em></strong> פותחת הוראה 4 במילים המובלטות <strong><em>פעל

        ל_</em></strong>, בערך <strong><em>השתדל</em></strong> פותחת הוראה 2 ב- <strong><em>

            השתדל אצל מישהו</em></strong>, השתדל לפני מישהו ובערך <strong><em>מזל</em></strong>

    פותחת הוראה 4 ב-<strong><em>מזל ש_</em></strong> והוראה 5 ב-<strong><em>למזלו</em></strong>,

    <strong><em>למזלו הטוב</em></strong>. צורה הנגזרת מן הערך או הבאה בתוספת אותיות

    שימוש, והדורשת ביאור בפני עצמה, הוצגה לחוד כערך משנה במסגרת הערך, בסופו; כך בתוך

    הערך <strong><em>מאה</em></strong> הוצג ערך המשנה <strong><em>המאה</em></strong>

    (בשתי משמעויות: המספר הסודר ותקופה של מאה שנים), בתוך הערך <strong><em>מאבק</em></strong>

    הוצג ערך המשנה <strong><em>המאבק</em></strong> (המלחמה בבריטים בתקופת המנדט), בתוך

    הערך <strong><em>מהירות</em></strong> הוצג תואר הפועל <strong><em>במהירות</em></strong>,

    ובתוך <strong><em>מחבוא</em></strong> הובא ערך המשנה <strong><em>מחבואים</em></strong>.

    במקום שהצורה הגזורה נתרחקה ריחוק ניכר מן הצורה העיקרית (<strong><em>גננת</em></strong>

    לעומת <strong><em>גנן</em></strong>) נקבע לה ערך נפרד.<br />

    לעולם לא ניתן ביאור אחד לחלקי

    דיבר שונים של מילה (כגון שם ותואר) אף אם מבחינה סמנטית ההוראות קרובות. שינוי בחלק

    הדיבר של המילה יוצר אפוא משמעות בפני עצמה, ובתחילת הביאור צוין חלק הדיבר השונה מחלק

    הדיבר שצוין בכניסת הערך; כך הערך <strong><em>מוזר</em></strong> המוגדר 'תואר' מוצג

    בהוראה 3 כ'תואר הפועל' וההוראה היא בהתאם לכך. לעיתים הסתפקנו לגבי חלק הדיבר הנוסף

    בהצגת דוגמה בלבד, בלא חזרה על ביאור כלשהו, וזאת כאשר משמעויות שני חלקי הדיבר קרובות

    מאוד זו לזו. תופעה זו נפוצה בעיקר בשמות תואר המשמשים גם כשמות עצם (ראה, למשל, הערכים

    <strong><em>אומלל, קנאי</em></strong> הוראה 4).<br />

    במקום שבין חלקי הדיבר השונים יש

    ריחוק סמנטי ניכר וכן במקום שכל אחד מחלקי הדיבר השונים מצריך פיצול למשמעויות אחדות

    או שיש צירופים שונים לחלקי הדיבר השונים, פוצל הערך לשני ערכים הומונימיים (ראה, למשל,

    הערכים <strong><em>יומית</em></strong> 1 – שם נ'; <strong><em>יומית</em></strong>2

    - תואר הפועל, וכן <strong><em>חזק</em></strong>1 – תואר, 8 משמעויות; <strong><em>חזק</em></strong>2

    – תואר הפועל, 4 משמעויות; <strong><em>צרפתי</em></strong>1 – שם, <strong><em>צרפתי</em></strong>2

    – תואר) .





</p>

<p>

    <span class="SubTitle2">י.<a name="j">הדוגמאות</a></span><br />

        <br />

    הדוגמאות הרבות המובאות במילוננו נועדו להציג את ש י מ ו ש י ה של המילה ויש בהן

        אם כן תוספת של ביאור. עלינו להדגיש שבמתן הדוגמאות לא התכוַונו כלל להביא עדים ממקורותיה

        של הלשון (כנהוג במילונים היסטוריים), ולפיכך אין הדוגמה מבקשת להציג את מקומה של המילה

        בתולדותיה של הלשון. כך, למשל, לא ימצא המעיין דוגמאות – 'עדויות' – מן המקרא למילים

        'מים', 'דלת', 'ראה', 'שלושים', אף שמילים אלה כולן מקראיות הן. כל כולה של הדוגמה

        לא באה אלא להציג באופן הטוב ביותר את שימושה של המילה בהקשרה הלשוני-חברתי כיום, ובכך

        להוסיף נופך לביאורה ולרמוז על הסביבה הלשונית הטבעית שלה. רוב הדוגמאות נוסחו אפוא

        לצורך מילון זה, ובניסוחן באה לידי ביטוי ההשקפה המוגדרת כאן. ערך או צירוף המוגדר

        כסלנג מודגם במשפט המנוסח כולו בסלנג (ראה <strong><em>למה מי אתה?</em></strong>),

        לזה המתוחם 'בלשון החוק' מובאת דוגמה מלשון החוק (ראה <strong><em>עוסק</em></strong>)

        וזה המוגדר כ'לשון ילדים' מודגם במשפט שנשמע כמותו מפי ילדים או בשיחה עימם (ראה <strong>

            <em>דודה</em></strong> הוראה 3). על אף תפיסה זו לא מנענו עצמנו כמובן מהבאת דוגמאות

        משלל מקורותיה של הלשון – המקרא וספרות חז"ל, הספרות הישנה והחדשה, השירה, התפילה והפיוט,

        שירי עם ושירי זמר – הכל לא כעדים בעלי ערך היסטורי אלא לצורך ההדגמה הטובה ביותר של

        המילה במשלב ובהקשר הטבעיים שלה. דוגמאות אלו שהן מובאות הוקפו תמיד במירכאות. בדוגמאות

        נקטנו את הכתיב הנוהג במילוננו פרט לציטוטים של פסוקים מן המקרא שאותם הבאנו בכתיבם

        המקראי המסורתי ובניקוד מלא. צורות של כתיב וקרי הובאו בפסוקים המצוטטים בצורת הקרי

        וצורת הכתיב צוינה בסוגריים. כמו כן נמנענו בכל מקום מכתיבת השם המפורש וכתבנו תחתיו

        'ה" כמקובל. במובאות מן השירה הוספנו לרוב ניקוד חלקי להקלת הקריאה. במקום שראינו בכך

        צורך קיצרנו את המובאה וציַינו להשמטה במתן שלוש נקודות. מאידך מצאנו לנכון להוסיף

        לפעמים (בסוגריים מרובעים) מילה אחת או יותר לצורך הבהרה. מראי מקומות מלאים נרשמו

        למובאות מן המקרא ומספרות חז"ל, והם נרשמו כמקובל בכתיבה המחקרית בימינו. בדוגמאות

        מן הספרות והשירה רשמנו רק את שם המחבר ללא מתן מראה מקום מדויק (חרגנו מכלל זה רק

        במקום שנראה לנו שציון שם היצירה חשוב בשל מקומה וחשיבותה בתולדות הספרות, כגון 'אל

        הציפור' של ביאליק). בדוגמאות מיצירות מתורגמות ציַינו את שם המתרגם (שהדוגמה היא,

        כמובן, פרי עטו) ולאחריו שם המחבר בשפת המקור המתורגמת (כגון:'י"ד ברקוביץ, תרגום שלום

        עליכם'). דוגמאות הלקוחות מן הפזמונאות העברית צוינו לרוב בציון הכללי 'שיר זמר'.&nbsp;





</p>

<p>

    <span class="SubTitle2">יא. <a name="k">האפראט הדקדוקי</a></span><br />

        <br />

    האפראט הדקדוקי מופיע בסוגריים מרובעים בסוף הביאור והוא כולל את הצורות הנטויות

    העיקריות של הערך ואת שורשו.<a href="#Note18">(18)</a>

    <br />

    <br />

    <strong>הצורות הנטויות<br />

    </strong>צורות הנטייה העיקריות של הערך, כשהן מנוקדות ניקוד מלא, הובאו על-פי הכללים

    הבאים <a href="#Note19">(19)</a>:

    <br />

    • בפעלים נמסרו הצורות האלה: המקור הנטוי כשלמ"ד בראשו, העבר בגוף מדבר, הבינוני ביחיד,

    העתיד בגוף מדבר והציווי בנוכח (כשאחריו סימן קריאה): <strong><em>שבר</em></strong>

    - לִשְׁבֹּר, שָׁבַרְתִּי, שׁוֹבֵר, אֶשְׁבֹּר, שְׁבֹר! סטינו מנוהג זה בכל מקום שצורה

    מן הצורות אינה סבירה או אינה קיימת למעשה לגבי הערך הנתון; כך, למשל, במקום שהשימוש

    בגוף מדבר אינו מקובל או הגיוני המרנו את צורות המדבר בצורות הנסתר (ראה בערכים <strong>

        <em>זלג, חלחל</em></strong>). מאותו טעם החסרנו לעיתים את צורת הציווי (ראה בערכים

    <strong><em>גסס, זקן</em></strong>).

    <br />

    • בשמות עצם נמסרה צורת הריבוי. כן נמסרו צורות הנסמך ביחיד ובריבוי (כשהן מסומנות

    במקף) בכל מקום שיש בצורות אלו שינוי מן הצורה היסודית, למעט השינויים הסדירים של צורני

    הנקבה וריבוי זכר בנסמך. כך, למשל, בערך <strong><em>סוס</em></strong> צוין באפראט

    רק הריבוי 'סוסים' ולא צורת הנסמך 'סוס-, סוסי-'; בערך <strong><em>כְּתָב</em></strong>

    צוינו הצורות כְּתָבִים, כְּתַב-, כִּתְבֵי-; בערך <strong><em>מלכה</em></strong>-

    מְלָכוֹת, מַלְכוֹת-, אך מַלְכַּת לא צוין מכיוון שהוא במסגרת השינוי הסדיר של הצורן.

    כן לא רשמנו את הצורות הנטויות של שמות תואר שהן צורות בינוני מן הבניינים הכבדים (משקלי

    מֻקְטָל, מְמֻקְטָל וכד') ונטייתם סדורה בקבוצתם (משקלי מֻקְטַל-, מֻקְטְלֵי-, מֻקְטְלוֹת-).

    עם זאת נתנו את הנטייה בכל מקום שצורות אלה שגורות מאוד בלשון (כגון מוסמך – מֻסְמְכֵי

    הפקולטה וכד'). גם בציון צורות הריבוי נהגנו בחיסכון מסוים ולא הבאנו צורות כאלה שאינן

    קיימות בשימוש למעשה אף אם הן קיימות להלכה מבחינה דקדוקית (כגון בערכים מופשטים דוגמת

    <strong><em>קלילות, עצבנות</em></strong> ובמונחים לועזיים מסוימים כגון <strong><em>ביולוגיה</em></strong>,

    ובמיוחד בארוכים שבהם).

    <br />

    • בשמות תואר ושמות עצם המוגדרים 'שֵׁם' (כלומר שמות עצם הגוזרים נקבה) מסרנו באפראט

    את צורות הנקבה ואת צורות הריבוי בזכר ובנקבה, והוספנו את צורת הנסמך אם יש בה, כאמור,

    שינוי מן הצורה היסודית, כגון <strong><em>גדול</em></strong> - גְּדוֹלָה, גְּדוֹלִים,

    גְּדוֹלוֹת, גְּדָל- ; שוטר – שׁוֹטֶרֶת, שׁוֹטְרִים, שׁוֹטְרוֹת (צרות הנסמך לא נרשמו).

    <br />

    • נטייה מלאה הבאנו באפראט של מילות היחס (בִּי, בְּךָ, בָּךְ וכו') וכן בכמה ערכים

    שיש ייחוד מסוים בנטייתם כמו <strong><em>אב</em></strong> (אָבִיךָ, אָבִיךְ וכו').

    האפראט מלווה לעיתים בהערות קצרות המחדדות את אופן השימוש בצורות המובאות בו. צורות

    נקבה או ריבוי מקבילות הובאו שתיהן באפראט (<strong><em>בכור</em></strong> – בְּכוֹרִים,

    בְּכוֹרוֹת; <strong><em>גמד</em></strong> – גַּמָּדָה/גַּמֶּדֶת). אם השימוש באחת

    הצורות הללו נדיר או מיושן או שיש בו עניין מיוחד, צוין הדבר במפורש (<strong><em>גוץ</em></strong>

    - גּוּצָה [גם: גּוּצִית, מיושׁן]). כן ציינו במפורש בידול סמנטי – אם הוא קיים – בין

    שתי הצורות המקבילות. כך נהגנו, למשל, בשמות התואר של הייחוס, כגון: <strong><em>צרפתי</em></strong>

    - צָרְפָתִית (גם: צָרְפָתִיָּה, בהתייחס לאדם בלבד) . בהערה זו רמזנו לשימוש המיוחד

    בשתי צורות אלו שהעברית המודרנית מבדילה באמצעותן בין 'מסעדה צרפתית' ל'סופרת צרפתייה'.

    ציון השימוש הנבדל של שתי הצורות המקבילות נעשה לעיתים על-ידי הפניה מן האפראט אל מספרי

    המשמעויות שבערך (ראה משל בערך סִינִי).

    <br />

    <br />

    <strong>השורש</strong>

    <br />

    השורש נרשם באפראט לאחר הצורות הנטויות <a href="#Note20">(20)</a>, וברישומו נהגנו לפי הכללים האלה: שורש

    המילה לא נרשם לגבי מילים ששורשן הוא חד או דו-עיצורי (<strong><em>פה, אב</em></strong>

    וכד'). במילים מבניין שִפְעֵל, שֻפְעַל והִשְתַּפְעֵל אימצנו את הגישה הרואה כאן בניין

    תנייני בשי"ן תחילית ולא שורש מרובע. שורשן של מילים אלו צוין אפוא כתלת-עיצורי, והבניין

    התנייני שִפְעֵל צוין בחלק הדיבר שבתחילת הערך, כרגיל, עם רמיזה לקשר שבינו ובין התצורה

    של בניין פיעל. כך, לדוגמא, צוין שורשו של הפועל <strong><em>שִעְבֵּד</em></strong>

    כ-ע.ב.ד. והבניין – פִיעל (שִפְעֵל). במקרים הבאים יופיע לאחר השורש ובסוגריים עגולים

    שורש נוסף:

    <br />

    • שורש תנייני, במקום שהמילה הנדונה נמנית עם משפחה שעימה נמנות גם מילים מן השורש

    הראשי, כגון <strong><em>התחיל</em></strong> – ת.ח.ל. (ח.ל.ל.), <strong><em>מיקש</em></strong>

    – מ.ק.ש. (י.ק.ש.) ועוד. (על המשפחה ראה להלן בפרק הבא).

    <br />

    • שורש משני תלת-עיצורי, כגון <strong><em>אבחן</em></strong> – א.ב.ח.נ. (ב.ח.נ.).

    <br />

    • שורש משני הקרוב לשורש המילה הנדונה (בעיקר בשורשים מן הגזרות העלולות) כשיש מילים

    הגזורות משני השורשים והנמנות על אותה משפחה, כגון השורש ב.ו.ז. (ב.ז.י.) הנרשם לצד

    המילה <strong><em>בוז</em></strong>, מכיוון שהיא חברה במשפחה שראשה הוא הפועל <strong>

        <em>ביזה</em></strong> ועם חברותיה נמנות גם <strong><em>בזוי, ביזיון, מבוזה</em></strong>

    ועוד – כולם מן השורש ב.ז.י. לעיתים רחוקות אף מסרנו לצד השורש הערה מפורשת בדבר הקשר

    עם שורש אחר קרוב כגון: <strong><em>נווה</em></strong> – נ.ו.י. (קרוב לשורש נ.א.י.).

    באמצעות הערה מסוג זה יוכל המעיין להבין, דרך משל, את העובדה שצורת הריבוי של נווה

    היא 'נאות' (נווה מדבר – נאות מדבר).

    





</p>

<p>

    <span class="SubTitle2">יב. <span><a name="l">משפחת המילים</a></span></span>

    (ראו הערה 16 לעיל)<br />

  <br />

          מקום מיוחד ייחדנו במילוננו לציון הזיקה שבין ערך נתון לחבריו הקרובים 'בני משפחתו'.

          במונח 'משפחה' אנו מתכוונים לקבוצת מילים המשותפות בשורשן ושמתקיים ביניהן קשר סמנטי

          הדוק. באופן זה מחולקת קבוצת כל המילים הגזורות משורש מסוים למספר משפחות בהתאם לשדה

          הסמנטי המשותף למשפחה. כך, למשל, יש בשורש ש.מ.ע. שלוש משפחות המתאימות לשדות הסמנטיים

          של 'שמיעה', 'משמעת' ו'משמעות' בהתאמה: (1) 'שמיעה' – השמיע, הושמע, השמעה, הישמעות,

          השתמע, מִשמע, נשמע, שומע, שימוע, שמועה, שמיעה, שמיעות, שמיעתי, שָׁמע, שֵׁמע, שמעי.

          (2) 'משמעת' – ממושמע, משמעת, משמעתי. (3) 'משמעות' – במשתמע, השתמע, השתמעות, משמע,

          משמעות, משמעותי, משמעי, משמען. (וראה גם המשפחות הנובעות מן השורש ח.ש.ב. – 'חשיבה',

          'חשיבות', 'חשבון', ו'מחשב', ומן השורש ח.ב.ר. – 'חבֵרוּת', 'חיבור', 'מחברת' ו'תחביר'.)

          לכל קבוצת מילים כזו נקבע "ראש משפחה" שהוא הערך ה"חזק" ביותר מכלל חברי המשפחה. ערך

          זה הוא לרוב פועל, ובדרך כלל הפועל בבניין קל (אם הוא קיים במשפחה זו) אלא אם כן נמצא

          שפועל בבניין אחר חזק ממנו. פעמים שהערך החזק הוא שֵׁם (לרוב שם שממנו נגזרו פעלים)

          ואז נקבע הוא כראש משפחה, כגון <strong><em>כחול</em></strong> שהוא ראש המשפחה שבו

          נכלל גם הפועל <strong><em>הכחיל</em></strong>. כן נקבעו כראשי משפחה שמות לועזיים

          שמהם נגזרו פעלים בתצורה עברית, כגון <strong><em>טלפון</em></strong> (בין חברי המשפחה

          נמצא גם <strong><em>טלפן</em></strong>) וכן מילים בסלנג המהוות בסיס ליצירת פעלים

          (<strong><em>חפיף</em></strong> – <strong><em>התחפף</em></strong>; <strong><em>באסה</em></strong>

          – <strong><em>התבאס</em></strong>). בכל מקרה אין הקורא נדרש לנחש מהו ראש המשפחה

          של קבוצת ערכים כלשהי, שכן בכל ערך מחברי המשפחה תימצא הפניה לראש המשפחה שלו. תחת

          ערך שהוא ראש משפחה, ובסופו, הובאו בסדר אלפביתי כל הערכים שבאותה משפחה. ערכים אלו

          הוצגו בצורתם המנוקדת כשלצד כל ערך שכתיבו חסר הניקוד שונה מכתיבו המנוקד הובאה בסוגריים

          צורתו בכתיב חסר הניקוד, כפי שהיא מופיע כערך במילון, כדי להקל על הקורא את מציאתה

          שם. בסופו של כל ערך שהוא חבר משפחה צוינה כאמור הפניה לערך המשמש כראש משפחתו: <strong>

              <em>הקריא</em></strong> &gt;&gt; <strong><em>קרא</em></strong>. גם מילים לועזיות

          יוצרות משפחה, אף שמושג השורש אינו קיים לגביהן (<strong><em>אינטלקט</em></strong>

          [ראש משפחה] – <strong><em>אינטלקטואל</em></strong>, <strong><em>אינטלקטואלי</em></strong>,

          <strong><em>אינטלקטואליות</em></strong>). מאידך ויתרנו על הצגת משפחה שכל חבריה הם

          שם פרטי והתואר הנגזר ממנו (<strong><em>ניגריה – ניגרי</em></strong>).

   

</p>

<p>

<span class="SubTitle2">יג. <a name="m">שיטת הכתיב והניקוד</a><br />

    </span>

    <br />

    הכתיב והניקוד שננקטו במילון זה הם אלה הנהוגים במפעל 'רַב מִלִּים'

        על שלוחותיו האלקטרוניות והמודפסות, והם עוצבו על-פי הכללים שאלו עיקריהם:

        <br />

        <br />

        <strong>הכתיב במילים עבריות </strong>

        <br />

        הכתיב הנוהג הוא בדרך כלל הכתיב חסר הניקוד כפי שנקבעו כלליו (לגבי מילים עבריות) על-ידי

        האקדמיה ללשון העברית. בפרטים אחדים חרגנו מכללי האקדמיה ונקטנו את צורת הכתיב המקובלת

        ברוב החומר היוצא כיום לאור, בספרות ובעיתונות, ואלה הם:<br />

        א. וי"ו מציינת תנועת o גם במילים שיש בהן קמץ קטן או חטף קמץ בצורות היסודיות (<strong><em>חוכמה,

            תוכנה, אומנות, אונייה</em></strong>).

        <br />

        ב. יו"ד מציינת תנועת i כשאין אחריה שווא נח גם במילים שבצורתן היסודית אין תנועת i

        (<strong><em>מיסים, ליבו</em></strong>); מצד שני אין היא נכתבת במקום שיש שווא נח

        אחרי תנועת i גם במילים שבצורתן היסודית אין שווא נח (<em><strong>זכרונות, זכרון דברים</strong></em>).

        <br />

        ג. יו"ד מציינת תנועת e במילים אחדות במשקל קְטֵלָה (<strong><em>אבידה, חשיכה, בריכה, ברירה</em></strong>

        ועוד), בעיקר כאשר יש מקום לבידול בין הומוגראפים ('שרפה' [שׂרֵפָה] לעומת 'שרפה' [שָׂרְפָה]).

        כן מצוינת תנועת היו"ד במילים ממשקל קֵטָל (<strong><em>שיער, שיכר</em></strong>),

        ובמילים אחדות שכתיבן ביו"ד מקובל ביותר (<strong><em>היפך, תיכף, פירות</em></strong>

        ועוד).

        <br />

        ד. העיצור יו"ד נכתב ביו"ד כפולה בסוף המילה רק במקום שיש צורך בהבחנה ממילה קרובה אחרת

        (<strong><em>לפניי</em></strong> [לְפָנַי] לעומת לפני [לִפְנֵי], <strong><em>שפתיי</em></strong>

        [שְפָתַי] לעומת שפתי [שִׂפְתֵי]). במקום שצורך זה אינו קיים או שהחשש לאי-הבחנה הוא

        רחוק נכתבה יו"ד אחת בלבד (<strong><em>בנותי</em></strong>).

        <br />

        <br />

        <strong>הניקוד והכתיב המנוקד של מילים לועזיות<br />

        </strong>1. תנועות u, o, i סומנו בחיריק מלא, חולם מלא ושורוק, בהתאמה (<strong><em>מִילְיוֹן,

            אוֹרְגָּנִי, טוּרְנִיר</em></strong>).

        <br />

        2. תנועת a מסומנת בקמץ בהברה פתוחה ובהברה סגורה מוטעמת בסוף המילה (<strong><em>קָטָלוֹג,

            דֶּמוֹקְרָט</em></strong>). בהברה סגורה שאינה בסוף מילה מסומנת תנועת a בפתח

        (<strong><em>פֶדֶרַצְיָה, פֶּדַנְטִיּוּת</em></strong>), וכן היא תסומן גם בהברה

        סופית המסתיימת בצרור עיצורים (<strong><em>מַרְק , אַבְּסְטְרַקְט</em></strong>).

        תנועת a מסומנת באל"ף גם בכתיב המנוקד כשלפניה העיצור יו"ד (<strong><em>לוֹיָאלִי, קְרָקוֹבְיָאק</em></strong>),

        במילים ממקור ערבי שבכתיב הערבי המקורי יש אל"ף (<strong><em>אִסְלָאם, עִירָאק</em></strong>)

        ובעוד מילים אחדות שכתיבן המקובל הוא באל"ף (<strong><em>מָאצ'וֹ, סָפָארִי</em></strong>

        ועוד) ובמיוחד כאלה שהן חד-הברתיות (<em><strong>פָּאבּ, וָאט , צָאר</strong></em>).<br />

        3. תנועת e מסומנת בסגול (<strong><em>פֶדֶרַצְיָה, פֶּדָגוֹג, תֶּזָה</em></strong>).

        כאשר אחרי התנועה e באה תנועה אחרת בלא עיצור ביניהן ובכתיב העברי מיוצגת תנועה זו

        באות אל"ף, תסומן ה- e בצירי (<strong><em>תּיֵאַטְרוֹן, מוּזֵיאוֹן, גֵּיאוֹגְרַפְיָה</em></strong>;

        על הכתיב ביו"ד ראה להלן).

        <br />

        4. דיפתונג ey מסומן בצירי והיו"ד שאחריו מנוקדת בשווא (<strong><em>לֵיְדִּי , גֵּיְזֶר</em></strong>).<br />

        5. דיפתונג eu מסומן בצירי מלא (<strong><em>אֵירוֹפָּה, אֵיקָלִיפְּטוּס</em></strong>),

        למעט מקרים אחדים שבהם הכתיב הנפוץ הוא אחר (<strong><em>נוֹיְרוֹלוֹגִי, נוֹיְטְרוֹן</em></strong>).

        במקרים אלו ציינו בהערה לכתיב התקני בצירי.

        <br />

        <br />

        <strong>הכתיב חסר הניקוד במילים לועזיות<br />

        </strong>דרך הכתיב חסר הניקוד של מילים לועזיות טרם הוסדרה בכללים של האקדמיה; לפיכך

        יש בכללים שהנחו אותנו והמפורטים בחלקם להלן גם משום הצעה להסדרת הכתיב בתחום זה.<br />

        1. אימות הקריאה יו"ד, וי"ו, אל"ף נכתבות בכל מקום שהן נכתבות בכתיב המנוקד (ראה לעיל).

        <br />

        2. תנועת e המסומנת בכתיב המנוקד בצירי מצוינת ביו"ד, והמסומנת בסגול נכתבת בלא יו"ד

        (<strong><em>גיאולוג, תזה</em></strong>).<br />

        3. תנועת a מצוינת באל"ף בכל המקומות שבהן היא נכתבת בכתיב המנוקד (ראה לעיל), ובנוסף

        גם בהברה פתוחה מוטעמת (<strong><em>ספונטאני, גנראטור</em></strong>) ובמספר מילים

        שכתיבן המקובל הוא באל"ף גם בהברה סגורה (<strong><em>מאפיה</em></strong> [מַפְיָה],

        <strong><em>מקאברי</em></strong> ועוד). מאידך האל"ף אינה נכתבת בהברה פתוחה שאינה

        מוטעמת (<strong><em>גלריה, קטלוג</em></strong>), בהברה סגורה (<em><strong>מנדט, גנרל,

            ויברציה</strong></em>) וכן במילים מעטות שכתיבן המקובל הוא בלא אל"ף גם בהברה

        פתוחה (<strong><em>גיטרה, דרמה</em></strong>).<br />

        4. העיצורים יו"ד, וי"ו נכתבים בהכפלה או בלעדיה לפי כללי הכתיב חסר הניקוד הנוהגים

        במילים עבריות, לכן: טלוויזיה, קוורץ, מניירה וכד' לעומת ולס, וסט וכד'.

        <br />

        <br />

        <strong>ציון ההטעמה</strong> <a href="#Note21">(21)</a><br />

        במילים שהטעמתן אינה מלרע צוינה ההטעמה על-ידי מתג בהברה המוטעמת. המתג מסומן בכניסת

        הערך המנוקד (מֶ|לֶךְ, דִּיאָלֶ|קְטִיקָה). הוספנו הערת הגייה מפורשת במקום שראינו

        בכך צורך ובעיקר בשני מקרים: (א) כדי להבדיל בין זוגות מילים הנבדלות ביניהן אך ורק

        בהטעמה (בִּירָה – בִּ|ירָה); (ב) במקום שראוי לציין את ההטעמה התקנית שאינה מקוימת

        בדרך כלל בלשון הדיבור (כגון <strong><em>אֶמְצַע</em></strong> – במלרע). ההטעמה לא

        צוינה בשמות תואר הנגזרים משם פרטי (<strong><em>יָפָּנִי</em></strong>) שלגבי רובם

        מתבקשת הגייה תקנית מלרעית, אלא שבלשון הדיבור הם נהגים ברובם במלעיל. כן היא לא צוינה

        באפראט הדקדוקי שבסוף הערך ואף לא בצירופים.&nbsp;<br />

        <br />     

    

     <p>

           <span >                   

                ***

               <br />



                כתבו

           </span>

          <span><strong>
       		    יעקב שוֵיקה וחיים א' כהן
          </strong></span>

         <br />

         <br />

         <br />

         על יסוד הנחיות העריכה של מערכת המילון</p>            

            <p class="SubTitle">

                <a name="3">הערות</a></p>

       <p>

      ההערות מתייחסות להבדלים בין הגרסה המודפסת של מילון רב-מילים לבין הגרסה המקוונת באתר רב-מילים:

           <br />



<a class="comment" name="Note1">(1)</a>	הסבר זה של הערך 'חם' מופיע במילון אבן שושן במהדורותיו ובהדפסותיו הרבות לאורך השנים. אכן במהדורה המחודשת של מילון זה, שיצאה לאור בשנת 2003, שוכתב הערך, ונוספו לו מרבית המשמעויות שהופיעו לראשונה במילון רב-מילים.

           <br />

           <a name="Note2">(2)</a> הערך דְּיוֹת נוסף למילון המקוון.

           <br />

<a class="comment" name="Note3">(3)</a>	במילון רב-מילים המקוון מופיעים גם שמות פרטיים עבריים ושמות משפחה נפוצים.

           <br />

<a class="comment" name="Note4">(4)</a>	במילון המקוון מופיעה בערך מסוג זה ההערה: (הסבר למילה זו מופיע רק בצירופים). הסבר הצירוף מופיע בלחיצה על לשונית הצירופים.

           <br />

<a class="comment" name="Note5">(5)</a>	במילון המקוון הערכים מופיעים בכתיב המנוקד, ואילו הכתיב חסר הניקוד (הכתיב המלא התקני) מוצג בלוח הדקדוקי, בלשונית 'דקדוק' (וכן משמש הכתיב המלא בניסוח ההסברים ודוגמאות השימוש, כמו במילון המודפס). אך יש לציין כי מערכת הניתוח המורפולוגי של רב-מילים מאפשרת במילון המקוון למצוא כל מילה בכל צורת כתיב (כתיב חסר או מלא, כתיב חלופי או שגוי) וכן כל צורת נטייה. הקלדת המילה כפי שנמצאה בטקסט כלשהו תציג את הערך המתאים.

           <br />

<a class="comment" name="Note6">(6)</a>	במילון המקוון נוסף הערך חַתְחַת במשמעות חדשה.

           <br />

<a class="comment" name="Note7">(7)</a>	במילון המקוון שונתה הערה זו, בהתאם לשינוי שחל בשימוש בצורת היחיד: (בלשון ימינו משמשת גם צורת היחיד 'משאב').

           <br />

<a class="comment" name="Note8">(8)</a>	הניתוח המורפולוגי במילון המקוון מייתר את הצורך בכניסת ערך נפרדת לצורת נטייה חריגה, הקלדת צורה כזו מביאה אוטומטית את הערך המתאים.

<a class="comment" name="Note9">(9)</a>	הניתוח המורפולוגי במילון המקוון מנתח ומזהה גם את חלופות הכתיב השונות, ומציג את הערך הרלוונטי בכתיב העיקרי, תוך ציון החלופות.

           <br />

<a class="comment" name="Note10">(10)</a>	 סעיף זה רלוונטי למילון המודפס בלבד.

           <br />

<a class="comment" name="Note11">(11)</a>	במילון המקוון מופיע הצירוף תחת כל אחת מן המילים המרכיבות אותו,   בלחיצה על לשונית 'צירופים'. סידור זה מאפשר לסקור במבט אחד את כל הצירופים שבהם משתתף ערך כלשהו מערכי המילון.

           <br />

<a class="comment" name="Note12">(12)</a>	במילון המקוון, ההבדל העיקרי בין הצרפים לניבים מתבטא בכך שחלק דיבר ניתן לצרפים בלבד.

           <br />

<a class="comment" name="Note13">(13)</a>	 בלשונית הצירופים במילון המקוון מופיעים כל הצירופים (הניבים והצרפים) ברשימה אלפביתית אחת.

           <br />

<a class="comment" name="Note14">(14)</a>	 חלקי הדיבר במילון המקוון מופיעים בטבלה בסוף ההערות.

           <br />

<a class="comment" name="Note15">(15)</a>	 במילון המקוון הקלדת הצורה הנטויה מציגה את הערך המילוני הרלוונטי.

           <br />

<a class="comment" name="Note16">(16)</a>	 המידע בדבר משפחות מילים (מילים השייכות לאותו שדה סמנטי ולאותו שורש)  חסר בשלב זה במילון המקוון.

           <br />

<a class="comment" name="Note17">(17)</a>	 סימון הצבעים במילון המקוון שונה, אך גם בו ערכי המשנה והמוסברים מצוינים באדום. להלן פירוט הצבעים המופיעים באתר רב-מילים:

                           צבע תכלת:  דוגמאות שימוש

                              צבע אפור בהיר: משלב, רובד לשוני או תחום (מופיע לפני ההסבר)

                              צבע ירוק: הפניה (שהיא לינק)

צבע אדום: מסמן מילים שאינן חלק מן ההסבר אלא צורה מסוימת של הערך המוסבר, או הקשר תחבירי מסוים שבו הוא מופיע.<br />

<a class="comment" name="Note18">(18)</a>	 הניתוח הדקדוקי מופיע במילון המקוון בלחיצה על הלשונית 'דקדוק'. הוא כולל את חלק הדיבר של המילה, מין, מספר (ולגבי פועל – גם בניין, זמן וגוף), אותיות שימוש, שורש וסמיכות. כמו כן מצוין הכתיב המלא התקני של המילה.

           <br />

<a class="comment" name="Note19">(19)</a>	 הצורות הנטויות המופיעות במילון המקוון, בלשונית 'דקדוק' תחת הכותרת נטיות , זהות לאלה המופיעות במילון המודפס.<br />

<a class="comment" name="Note20">(20)</a>	 במילון המקוון מוצג השורש בשורה הלפני אחרונה בלוח הדקדוקי שבלשונית 'דקדוק'.

           <br />

<a class="comment" name="Note21">(21)</a>	 ציון ההטעמה אינו מופיע בשלב זה במילון המקוון.



</p>

       <p class=""><a name="4"><strong>חלקי הדיבר במילון המקוון</strong></a><br />

           <br />

            ליד <strong>שמות עצם</strong> מופיע ציון משולב של <span>מין ומספר</span>:

            <br />

           <strong>שֵם ז' </strong>- שם עצם בלשון זכר (ילד)

            <br />

           <strong>

            שֵם נ' </strong>- שם עצם בלשון נקבה (ילדה)<br />

           <strong>שֵם ז"ר</strong> – שם עצם בלשון זכר בריבוי (שמיים)

            <br />

           <strong>שֵם נ"ר </strong>– שם עצם בלשון נקבה בריבוי (תשואות)<br />

           <strong>שֵם ז"ר</strong> (בצורת זוגי) - שם עצם בלשון זכר בריבוי בצורת הזוגי (מכנסיים)<br />

           <strong>שֵם נ"ר</strong> (בצורת זוגי) – שם עצם בלשון נקבה בריבוי בצורת הזוגי (כיריים)

            <br />

           <strong>

            שֵם זו"נ </strong>– שם עצם שהוא גם זכר וגם נקבה (סכין)<br />

           <strong>שֵם </strong>– שמות עצם שיש להם צורות נטייה לזכר ולנקבה (תלמיד, פקיד וכדומה)<br />

           <strong>תואר</strong> (יפה, גדול)<br />

            ליד <strong>פעלים</strong> מופיע ציון משולב של פועל ובניין: פ' קל – פועל בבניין קל (שמר)<br />

           <strong>פ' נפעל</strong> - פועל בבניין נפעל (נשמר)<br />

           <strong>פ' פיעל </strong>- פועל בבניין פיעל (שימר)<br />

           <strong>פ' פועל</strong> – פועל בבניין פֻּעַל (שומר)<br />

           <strong>פ' התפעל </strong>- פועל בבניין התפעל (התלבש)<br />

           <strong>פ' הפעיל</strong> – פועל בבניין הפעיל (הלביש)<br />

           <strong>פ' הופעל </strong>– פועל בבניין הופעל (הולבש)<br />

           <strong>תואר הפועל</strong> (לאט, שוב)

            <br />

           <strong>מילת יחס</strong> (אל, עם)<br />

           <strong>

            מילת קריאה</strong> (אוי, הידד)<br />

           <strong>

            מילת חיבור</strong> (אלא, כי)<br />

           <strong>מילת שאלה</strong> (מי, למה)<br />

           <strong>מילת הסבר</strong> (כלומר, דהיינו)

            <br />

           <strong>כינוי נפרד </strong>(אני, אתם)<br />

           <strong>

            כינוי סתמי</strong> (כלשהו)<br />

           <strong>

            כינוי רומז לקרוב </strong>(זאת, אלה)<br />

           <strong>

            כינוי רומז לרחוק</strong> (ההוא, ההן)<br />

           <strong>כינוי שאלה</strong> (איזה, אילו)

            <br />

           <strong>

            מספר מונה</strong> (חמש, עשרה)

            <br />

           <strong>

            מספר סודר </strong>(חמישי, עשירי)<br />

           <strong>מספר מחלק</strong> (שליש, רבע)

            <br />

           <strong>תחילית</strong> (דו-, גיאו-)<br />

           <strong>סופית</strong> (-לוגיה, -גראפי)

            <br /></p>

        </div>

   </td>

        </tr>

       </table>
`;

export default editorNoteHtml;
